import en from "vuetify/lib/locale/en";
import { Translations } from "./language-translations";
import Role from "../../../views/dashboard/models/Role";
import Order from "../../../views/dashboard/models/Order";
import Offer from "../../../views/dashboard/models/Offer";
import startCase from "lodash-es/startCase";
import SalePage from "../models/salePage/SalePage";
import Store from "@/assets/js/models/domain/Store";
import Notification from "../../../views/dashboard/models/Notification";
import Ticket from "../../../views/dashboard/models/Ticket";
import Invoice from "../../../views/dashboard/models/Invoice";
import Product from "../../../views/dashboard/models/Product";
import Inventory from "../../../views/dashboard/models/Inventory";
import User from "@/assets/js/models/user/User";
import PreSellPage from "../../../views/dashboard/models/PreSellPage";
import Stripe from "../../../views/dashboard/models/Stripe";
import Pixel from "../../../views/dashboard/models/Pixel";
import UserIdVerification from "../../../views/dashboard/models/UserIdVerification";
import Warehouse from "../../../views/dashboard/models/Warehouse";
import { product_feed_types } from "../global-constants";
import AllowedCountriesAddon from "../../../views/dashboard/models/AllowedCountriesAddon";
import StorePage from "../../../views/dashboard/models/StorePage";
import * as salePageBlockFills from './en/sale_page_blocks';
import network_sdk_account from "./en/network_sdk_account";
import google_sheet from "./en/google_sheet";
import store from "./en/store.js";
import product_page from "./en/product_page.js";
import Option from "../models/salePage/Option";
import SubscriptionPlan from "../models/SubscriptionPlan/SubscriptionPlan";
import warehouses_page from "./en/warehouses_page";
import subscription_invoices_page from "./en/subscription_invoices_page";
import referral_program_page from "@/assets/js/translations/en/referral_program_page";
import ECommerceSdkAccount from "@/assets/js/models/ECommerceSdk/ECommerceSdkAccount";
import CheckoutFormSettings from "@/assets/js/models/salePage/FormSettings/CheckoutFormSettings";
import GoogleSheet from "@/assets/js/models/GoogleSheet/GoogleSheet";
import order_page from "@/assets/js/translations/en/order_page";
import sale_page_page from "@/assets/js/translations/en/sale_page_page";
import seller_page from "@/assets/js/translations/en/seller_page";
import ProductVariation from "@/assets/js/models/product/ProductVariation";
import ProductScraper from "@/assets/js/models/Scraper/ProductScraper";
export default {
  rtl: false,
  ...en,
  ...Translations.en,
  sale_page_block_fills: salePageBlockFills.default,
  network_sdk_account: network_sdk_account,
  subscription_invoices: subscription_invoices_page,
  google_sheet,
  therms: {
    tutorial: 'tutorial',
    category: 'category',
    faq_category: 'Faq category',
    loading_failure: 'Loading failure, please try again later.',
    n_a: 'N/A'
  },
  app_bar: {
    store_field: {
      placeholder: 'All Stores',
      view_store: 'View Store'
    }
  },
  global_text: {
    table: {
      filters: 'Filters',
      no_filter_selected: 'No filters selected.'
    },
    show_more: 'show more',
    show_less: 'show less',
    world_wide: 'World Wide',
    languages: {
      en: 'English',
      ar: 'Arabic'
    },
    pagination: {
      items_per_page: 'items per page'
    },
    offer_option_buy_x_times: 'Buy 1x {offer_name}',
    block_tabs: {
      settings: 'Settings',
      content: 'Content',
      style: 'Style'
    },
    go_home: 'go home',
    access_denier: 'Access Denied',
    please_fill_mandatory_fields: 'Please fill out mandatory fields.',
    no_something_found: 'No {thing} found.',
    something_went_wrong: 'Something went wrong, please try again.',
    please_wait: 'Loading... Please wait',
    total: 'Total',
    no_country: 'no country',
    no_result_matching: 'No results matching',
    yes: 'yes',
    no: 'no',
    no_permission_selected: 'No permission selected',
    new_notification: 'You have a new {type} message',
    date: {
      today: 'Today',
      yesterday: 'Yesterday',
      this_month: 'This Month',
      last_month: 'Last Month',
      this_week: 'This Week',
      last_week: 'Last Week',
      this_year: 'This Year'
    },
    payment_fields: {
      bank_details: {
        country: 'Country',
        beneficiary_name: 'Beneficiary Name',
        bank_name: 'Bank Name',
        account_number: 'Account Number',
        swift_code: 'Swift Code',
        address: 'Address'
      },
      payoneer: {
        name: 'Name',
        email: 'Email'
      }
    }
  },
  tutorialDialog: {
    title: 'Tutorials',
    section_side_bar: 'section on the Sidebar.',
    tip: 'Tip: If you dont want to see this popup again, ' + 'please click on “Ok All is Clear Button”, and If' + ' you still want to see more tutorials like this ' + 'you can find them on the',
    buttons: {
      ok: 'Ok all is clear',
      see_later: 'See it later'
    }
  },
  dashboardMenu: {
    create_ticket: 'Create Ticket',
    your_account_manager: 'Your Account Manager',
    score: 'Score :',
    points: 'points',
    points_to: 'points to level',
    points_to_order: '1 point = 1 delivered order',
    level: 'Level',
    points_to_level: 'points to',
    join_whats_app_group: 'Join our whatsapp group',
    overview: {
      title: 'Overview',
      children: {}
    },
    business_managers: {
      title: 'Applications',
      children: {
        woocommerce: {
          title: 'WooCommerce'
        },
        google_sheet: {
          title: 'Google Sheet'
        },
        google_shopping: {
          title: 'Google Shopping'
        },
        facebook_shopping: {
          title: 'Facebook Shopping'
        }
      }
    },
    sale_pages: {
      title: 'Sales pages',
      children: {
        original_sale_pages: {
          title: 'Original Sale Pages'
        },
        generated_sale_pages: {
          title: 'Generated Sale pages'
        }
      }
    },
    product_sale_pages: {
      title: 'Sale pages'
    },
    pre_sell_pages: {
      title: 'Pre-sell pages',
      children: {
        original_pre_sell_pages: {
          title: 'Original Pre-sell Pages'
        },
        generated_pre_sell_pages: {
          title: 'Generated Pre-sell pages'
        }
      }
    },
    orders: {
      title: 'Orders',
      children: {}
    },
    tested_orders: {
      title: 'Tested orders',
      children: {}
    },
    sale_reports: {
      title: 'Statistics',
      children: {}
    },
    trending: {
      title: 'Trending',
      children: {}
    },
    domains: {
      title: 'Domains',
      children: {}
    },
    store: {
      title: 'Store Settings',
      children: {
        store_settings: {
          title: 'Stores',
          children: {}
        },
        store_pages: {
          title: 'Store pages',
          children: {}
        },
        store_layouts: {
          title: 'Store layouts',
          children: {}
        }
      }
    },
    settings: {
      title: 'General Settings',
      children: {}
    },
    call_center: {
      title: 'Call Center',
      children: {}
    },
    notifications: {
      title: 'Notifications',
      children: {}
    },
    support: {
      title: 'Support',
      children: {
        faq: {
          title: 'Faqs'
        },
        ticket: {
          title: 'Tickets'
        },
        tutorials: {
          title: 'Tutorials'
        }
      }
    },
    network_sdks: {
      title: 'External APIs'
    },
    warehouse: {
      title: 'Warehouses Settings',
      children: {
        warehouse: {
          title: 'Warehouses'
        },
        inventory: {
          title: 'Inventory'
        },
        external_api: {
          title: 'External API'
        }
      }
    },
    advertiser: {
      title: 'Advertiser',
      children: {}
    },
    product: {
      title: 'Products',
      children: {}
    },
    inventory_overview: {
      title: 'Inventory Overview',
      children: {}
    },
    sellers: {
      title: 'Sellers',
      children: {}
    },
    referral_program: {
      title: 'Referral Program',
      children: {
        link: {
          title: 'Referral Link'
        },
        invoices: {
          title: 'Referral Invoices'
        },
        payouts: {
          title: 'Referral Payouts'
        }
      }
    },
    activity_logs: {
      title: 'Activity Logs',
      children: {}
    },
    accounting: {
      title: 'Accounting',
      children: {}
    },
    users: {
      title: 'Users',
      children: {
        user_accounts: {
          title: 'User Accounts'
        },
        identity_verification: {
          title: 'Identity Verification'
        }
      }
    },
    invoices: {
      title: 'Settings',
      children: {
        subscription_invoices: {
          title: 'Subscription Invoices'
        },
        settings: {
          title: 'Account Settings'
        },
        pending_orders: {
          title: 'Eligible Orders'
        },
        payouts: {
          title: 'Payouts'
        },
        warehouse_remittances: {
          title: 'Warehouse Remittances'
        },
        warehouse_expenses: {
          title: 'Warehouse Expenses'
        },
        advertiser_commission: {
          title: 'Advertiser Commission'
        },
        referrer_commissions: {
          title: 'Referrals'
        }
      }
    },
    media_library: {
      title: 'Media Library',
      children: {}
    },
    leads: {
      title: 'Leads',
      children: {}
    },
    offers_requests: {
      title: 'Offer Requests',
      children: {}
    },
    login: {
      title: 'Login'
    },
    register: {
      title: 'Register'
    },
    request_password: {
      title: 'Request password'
    },
    reset_password: {
      title: 'Reset password'
    },
    register_confirmation: {
      title: 'Register confirmation'
    },
    instagram_redirect: {
      title: 'Instagram redirection'
    }
  },
  validation_request: {
    check_your_email: 'You have now created your account successfully! Please check your email and respond to our signup survey.',
    ps_approve: '<strong>P.S</strong> : Your dashboard will be Active after we approve your account.',
    approve_may_take: 'Approval may take 1 or 2 days',
    send_instagram_message: 'To speed up the verification process, please send us a message on Instagram <a target="_blank" style="color: deepskyblue" href="https://www.instagram.com/maxcom.network">@maxcom.network</a>',
    logout: 'logout'
  },
  page_not_found: 'Not Found',
  email_verification: {
    data_check: 'Data check..., please wait.',
    redirection: 'Redirecting..., please wait.'
  },
  pagination: {
    all: 'All'
  },
  global_errors: {
    mandatory_fields: 'Please fill out mandatory fields.'
  },
  overview: {
    visits: 'Visits',
    orders: 'Orders',
    earnings: 'Earnings',
    today: 'Today',
    yesterday: 'Yesterday',
    this_month: 'This Month',
    last_month: 'Last Month',
    all_time: 'All Time',
    no_earning_today: 'No earnings generated today',
    no_earning_yesterday: 'No earnings generated yesterday',
    no_earning_this_month: 'No earnings generated this month',
    confirmed_earnings: 'Confirmed Earnings ( Delivered orders )',
    top_5_offer_earnings: 'Earnings of your TOP 5 Products',
    top_5_country_earnings: 'Earnings of your TOP 5 Countries'
  },
  trending: {
    visits: 'Visits',
    orders: 'Orders',
    earnings: 'Earnings',
    today: 'Today',
    yesterday: 'Yesterday',
    this_month: 'This Month',
    last_month: 'Last Month',
    all_time: 'All Time',
    no_trending_today: 'Nothing is trending today',
    no_trending_yesterday: 'Nothing is trending yesterday',
    no_trending_this_month: 'Nothing is trending this month',
    confirmed_earnings: 'Confirmed Earnings ( Delivered orders )',
    top_5_offer_earnings: 'Earnings of your TOP 5 Offers',
    top_5_country_earnings: 'Earnings of your TOP 5 Countries',
    top_5_released_offer_payout: 'Last 5 released Offers Payout',
    top_5_seller_payout: 'Top 5 Sellers of the month Payout'
  },
  offer_page: {
    no_offers_found: 'No offers found.',
    you_will_achieve_level: 'You are on {level_name}, you will see more offers when you achieve the next level.',
    create_offer: 'Create new offer',
    filter: {
      search: {
        placeholder: 'Filter offers ...'
      },
      advertiser: {
        placeholder: 'All advertisers'
      },
      country: {
        placeholder: 'All countries'
      },
      type: {
        option_all: 'All types'
      },
      status: {
        option_all: 'All status'
      },
      commission_type: {
        option_all: 'All commission types'
      },
      level: {
        option_all: 'All levels'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    offer_item: {
      sale_price: 'Sale price',
      payout: 'Commission',
      target_countries: 'Target countries',
      undefined: 'Undefined',
      statistics: {
        title: 'Offer stats',
        confirmation_rate: {
          tooltip: 'Confirmation rate'
        },
        delivery_rate: {
          tooltip: 'Delivery rate'
        },
        product_quantity: {
          tooltip: 'Remaining product quantity',
          states: {
            low: 'Low',
            medium: 'Medium',
            high: 'High'
          }
        },
        affiliate_on: {
          tooltip: 'Affiliates promoting offer in the last 7 days'
        }
      },
      buttons: {
        details: 'Details',
        sale_page: 'Sale page',
        review: 'Review',
        edit: 'Edit',
        pixels: 'Pixels',
        tracking: 'Tracking',
        delete: 'Delete'
      }
    },
    tabs: {
      offer_id: 'Offer id: {id}',
      overview: 'Overview',
      creatives: 'Creatives',
      pixels: 'Pixels',
      tracking_links: 'Tracking links'
    },
    dialogs: {
      delete: {
        title: 'Delete offer',
        content: 'Pausing or deleting the offer will impact the elements attached to it. Are you sure you want to proceed ?'
      }
    },
    offer_request_form: {
      review_offer_request: 'Review Offer Request',
      request_btn: 'Request Offer',
      cancel_btn: 'Cancel',
      fields: {
        full_name: {
          title: 'Full name',
          placeholder: 'type your full name'
        },
        phone: {
          title: 'Phone',
          placeholder: 'type you phone number'
        },
        postal_code: {
          title: 'Postal code',
          placeholder: 'type your postal code'
        },
        delivery_address: {
          title: 'Delivery Address',
          placeholder: 'type you delivery address'
        },
        country: {
          title: 'Country',
          placeholder: 'Select your country'
        },
        city: {
          title: 'City',
          placeholder: 'type your city'
        },
        email: {
          title: 'Email',
          placeholder: 'example@example.com'
        },
        region: {
          title: 'Regions',
          placeholder: 'type your region'
        }
      }
    },
    form: {
      offer_commission_for_statuses: {
        [Order.DELIVERED_STATUS]: startCase(Order.DELIVERED_STATUS),
        [Order.CONFIRMED_STATUS]: startCase(Order.CONFIRMED_STATUS)
      },
      toggle_form: 'Click here to create an offer.',
      create_offer: {
        title: 'Create Offer',
        subtitle: 'Create new offer'
      },
      update_offer: {
        title: 'Update Offer',
        subtitle: 'Update offer'
      },
      step_one: 'Step 1: Offer info',
      step_two: 'Step 2: Product creatives for Ads',
      step_three: 'Step 3: Preview Sales pages:',
      you_offer_will_be: 'Your offer will be saved as draft, you will have to activate it after you create the sale page.',
      offer_sale_page_list: {
        title: 'Offer sale pages list',
        preview: 'preview page',
        copy: 'copy page link'
      },
      create_btn: 'Create Offer',
      save_btn: 'Save Offer',
      cancel_btn: 'Cancel',
      duplicate_btn: 'Duplicate Offer',
      edit_btn: 'Edit offer',
      delete_btn: 'Delete offer',
      request_btn: {
        shipped: 'Request Shipped',
        new: 'Request offer',
        requested: 'Offer Requested'
      },
      fields: {
        product: {
          title: 'Offer Product',
          placeholder: 'Select product'
        },
        name: {
          title: 'Offer name',
          placeholder: 'type a name'
        },
        type: {
          title: 'Offer type'
        },
        status: {
          title: 'Offer status'
        },
        payment_type: {
          title: 'Payment by'
        },
        status_for_commission: {
          title: 'Commission for'
        },
        description: {
          title: 'Offer description',
          placeholder: 'type a description'
        },
        level: {
          title: 'Offer level required'
        },
        exclusive_users: {
          title: 'Offer exclusive users',
          placeholder: 'Select users'
        },
        payout: {
          title: 'Offer payout',
          placeholder: 'set a payout'
        },
        commission: {
          title: 'Network commission',
          placeholder: 'set a commission'
        },
        shipping_countries_select_type: {
          title: 'Shipping countries select type'
        },
        country: {
          title: 'Offer Country',
          placeholder: 'Select a country'
        },
        statistics: {
          title: ''
        },
        shipping_countries: {
          title: 'Offer Shipping Countries',
          placeholder: 'Select the offer shipping countries'
        },
        creative_ad: {
          title: 'Offer product ad copy',
          placeholder: 'type your product ad copy description'
        },
        creative_images: {
          title: 'Offer ad images',
          placeholder: 'choose your product images collection'
        },
        creative_videos: {
          title: 'Offer ad videos',
          placeholder: 'choose your product videos collection'
        },
        domain: {
          title: 'Offer domain',
          placeholder: 'Select a domain'
        }
      }
    },
    offer_overview: {
      commission_required_status: {
        [Offer.COD_PAYMENT_TYPE]: {
          [Order.DELIVERED_STATUS]: 'For Delivered',
          [Order.CONFIRMED_STATUS]: 'For Confirmed'
        },
        [Offer.CARD_PAYMENT_TYPE]: {
          [Order.DELIVERED_STATUS]: 'Per Sale'
        }
      },
      description: 'Offer Description',
      level: 'Offer Level',
      status: 'Offer Status',
      payout: 'Offer Payout',
      country: 'Target Country',
      sale_price: 'Sale Price',
      preview_sale_pages: 'Preview Sales Pages',
      preview_pre_sell_pages: 'Preview Pre-sell Pages',
      no_sale_page: 'No sale page available in this offer.',
      no_pre_sell_page: 'No pre-sell page available in this offer.'
    },
    offer_creatives: {
      ad_copy: 'Ad copy',
      images: 'Images',
      videos: 'Videos',
      no_creative_images_found: 'No images found.',
      no_creative_videos_found: 'No videos found.',
      buttons: {
        copy_link: 'copy link',
        download: 'download'
      }
    },
    generated_page_item: {
      preview: 'Preview',
      copy_page_link: 'copy page link'
    },
    offer_tracking_links: {
      advanced_options: 'Advanced options',
      preview: 'Preview',
      tabs: {
        sale_page: 'Generate sale page',
        pre_sell_page: 'Generate pre-sell page'
      },
      form: {
        sale_pages: {
          placeholder: 'Select sale page'
        },
        pre_sell_pages: {
          placeholder: 'Select pre-sell page'
        },
        domain: {
          our_domain: {
            title: 'Page link from our Domains :',
            placeholder: 'Select from our domains'
          },
          your_domain: {
            title: 'Page link from your Domains :',
            placeholder: 'Select from your domains'
          }
        }
      },
      generate_your_sale_page: 'Generate your sale page',
      generate_your_pre_sell_page: 'Generate your pre-sell page',
      modal: {
        sale_page_delete_message: {
          title: 'Delete Sale page',
          text: 'Are you sure, you want to delete this sale page ?'
        },
        pre_sell_page_delete_message: {
          title: 'Delete Pre-sell page',
          text: 'Are you sure, you want to delete this pre-sell page ?'
        }
      },
      generate_link_placeholder: {
        your_sale_page_link_ready: 'Your links ready to promote ( you can edit the pages on the sales pages section ).',
        your_pre_sell_page_link_ready: 'Your links ready to promote ( you can edit the pages on the pre-sell pages section ).',
        sale_page_link: 'Sales page link : ',
        pre_sell_page_link: 'Pre-sell page link : ',
        sale_page_will_appear_here: 'your generated link will appear here.',
        pre_sell_page_will_appear_here: 'your generated link will appear here.'
      },
      your_generated_sale_pages: 'Your generated sales pages',
      your_generated_pre_sell_pages: 'Your generated pre-sell pages',
      no_sale_page_available: 'No sale page available.',
      no_pre_sell_page_available: 'No sale page available.'
    },
    offer_pixels: {
      here_you_can_see: 'Here you can see the pixels ID you have setup in your account settings, ' + 'but you can also replace it with a new pixel ID just for this offer if you paste it here.',
      want_other_pixel: 'Want other pixel in thank you page ? contact your account manager.',
      only_for_seller: 'This section is only for sellers/influencers, Login as a seller account to see and Edit.',
      save: 'Save',
      reset: 'Reset',
      form: {
        facebook_pixel: {
          title: 'facebook pixel ID',
          placeholder: 'Pixel ID'
        },
        snapchat_pixel: {
          title: 'snapchat pixel ID',
          placeholder: 'Pixel ID'
        },
        twitter_pixel: {
          title: 'twitter pixel ID',
          placeholder: 'Pixel ID'
        },
        google_pixel: {
          title: 'google tag ID',
          placeholder: 'GTM-XXXXXXX'
        },
        tiktok_pixel: {
          title: 'tiktok pixel ID',
          placeholder: 'Pixel ID'
        },
        postback_url: {
          title: 'postback url',
          placeholder: 'https://your_postback_url?cid={cid}&payout={payout}'
        }
      }
    }
  },
  pre_sell_page_page: {
    create_pre_Sell_page: 'create new pre-sell page',
    no_pre_sell_pages_found: 'No pre-sell pages found.',
    pre_sell_page_edited_by: 'Last edited by {user_name} ( {user_role} )',
    pre_sell_page_generated_by: 'Generated by {user_name} ( {user_role} )',
    pre_sell_page_more_info: '<span style="color: var(--app-primary-color)">' + 'Performance : ' + '<span style="color: var(--app-info-color)">visits</span> {page_visits}, &nbsp;' + '<span style="color: var(--app-success-color)">clicks</span> {page_clicks}, &nbsp;' + '<span style="color: var(--app-fire-color)">click rate</span> {clicks_rate} %</span>',
    page_not_up_to_date_alert: 'This page is not up to date, please save it or revert changes by clicking the reset button above.',
    dialogs: {
      delete: {
        title: 'Delete Pre-sell page',
        content: 'Pausing or deleting the pre-sell page will impact the elements attached to it. Are you sure you want to proceed ?'
      }
    },
    filter: {
      search: {
        placeholder: 'Filter pre-sells ...'
      },
      offers: {
        option_all: 'All offers'
      },
      users: {
        option_all: 'All users'
      },
      sort_by: {
        text: 'Sort by',
        options: {
          date: 'Date',
          visits: 'Visits',
          orders: 'Orders',
          clicks: 'Clicks'
        }
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    pre_sell_page_form: {
      rectangle_image_info: 'Please use a rectangular image for better view',
      page_title: 'Page title: {title}',
      offer_name: 'Offer name: {offer_name}',
      product_sku: 'Product sku: {sku}',
      toggle_form: 'Click here to create a pre-sell page',
      create_pre_sell_page: {
        title: 'Create pre-sell page',
        subtitle: 'Create new pre-sell page'
      },
      update_pre_sell_page: {
        title: 'Update pre-sell page',
        subtitle: 'Update pre-sell page'
      },
      buttons: {
        create: 'Create page',
        delete: 'Delete page',
        save: 'Save page',
        preview: 'Preview page',
        duplicate: 'Duplicate page',
        cancel: 'Cancel',
        reset_form: 'Reset form',
        add_pixel: 'Add pixel'
      },
      steps: {
        one: {
          title: 'Step {step}: Pre-sell page info'
        },
        two: {
          title: 'Step {step}: Pre-sell page elements'
        },
        addons: {
          title: 'Page addons'
        },
        blocks: {
          title: 'Pre-sell Page content'
        },
        tracking: {
          title: 'Page pixels tracking'
        }
      },
      fields: {
        domain: {
          title: 'Pre-sell page domain',
          placeholder: 'Select you domain'
        },
        sale_page: {
          title: 'Pre-sell page sale page',
          placeholder: 'Select you sale page'
        },
        page_title: {
          title: 'Pre-sell page title',
          placeholder: 'type your sale page title'
        },
        page_url_title: {
          title: 'Pre-sell page url title',
          placeholder: 'type the page url title'
        },
        add_block: {
          title: 'Add new content',
          button_title: 'Add to page'
        }
      },
      addon_fields: {
        show_navbar: {
          title: 'Show pre-sell page navbar'
        },
        sticky_buy_button: {
          title: 'Sticky BUY NOW Button'
        }
      }
    }
  },
  sale_page_page: sale_page_page,
  store: store,
  store_page_page: {
    filter: {
      page: {
        placeholder: 'All pages'
      },
      domain: {
        placeholder: 'All stores'
      },
      language: {
        placeholder: 'All languages'
      }
    },
    dialogs: {},
    form: {
      fields: {
        language: {
          title: 'Language',
          placeholder: 'Select a language'
        },
        type: {
          title: 'Page name',
          placeholder: 'Select a page name'
        },
        domain: {
          title: 'Domain',
          placeholder: 'Select a domain'
        },
        blocks: {
          title: 'Store page content',
          buttons: {
            add_block: {
              title: 'Add block'
            }
          }
        }
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save page'
      },
      update_store_page: {
        title: 'Update store page'
      }
    }
  },
  order_page,
  sale_reports_page: {
    filter: {
      offers: {
        all_option: 'All Offers'
      },
      countries: {
        all_option: 'All Countries'
      },
      sellers: {
        all_option: 'All Affiliates'
      },
      products: {
        all_option: 'All Product'
      },
      call_agents: {
        all_option: 'All Call agents'
      },
      by_period: {
        daily: 'Daily',
        monthly: 'Monthly'
      }
    },
    chart_tooltip: {
      date: 'Date : {v}',
      visits: 'Visits : {v}',
      orders: 'Orders : {v}',
      sales: 'Sales : {v}',
      confirmed: 'Confirmed : {v}',
      confirmation_rate: 'Confirmation Rate : {v}',
      earnings: 'Earnings : {v}',
      delivered: 'Delivered : {v}',
      delivery_rate: 'Delivery Rate : {v}',
      confirmed_sales: 'Confirmed Sales : {v}',
      confirmed_earnings: 'Confirmed Earnings : {v}'
    },
    tables: {
      total: 'Total',
      stats_by_country: {
        title: 'Stats by country',
        visits: 'Visits',
        country: 'Country',
        conversions: 'Orders (Leads)',
        payouts: 'Payouts',
        sales_amount_usd: 'Sales amount in USD',
        sale_country_currency: 'Sales in Country currency',
        confirmed_sales: 'Delivered orders',
        confirmed_payouts: 'Confirmed Payouts',
        confirmed_sale_country_currency: 'Confirmed Sales in Country currency',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        delivery: 'Delivery %'
      },
      stats_by_referrer: {
        title: 'Stats by referrer',
        visits: 'Visits',
        referrer: 'Referrer',
        conversions: 'Orders (Leads)',
        payouts: 'Payouts',
        sales_amount_usd: 'Sales amount in USD',
        confirmed_sales: 'Delivered orders',
        confirmed_payouts: 'Confirmed Payouts',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        delivery: 'Delivery %'
      },
      sale_page_sale_report: {
        title: 'Stats by sale page',
        seller_name: 'Seller name',
        visit_count: 'Visits',
        sale_page_link: 'Sale page',
        lead_count: 'Orders (Leads)',
        lead_payout_sum: 'Payouts',
        lead_sale_usd_total: 'Sales amount in USD',
        lead_sale_total: 'Sales in Country currency',
        paid_out_orders_count: 'Delivered orders',
        paid_out_orders_payout_sum: 'Confirmed Payouts',
        paid_out_orders_sale_total: 'Confirmed Sales in Country currency',
        paid_out_orders_sale_usd_total: 'Confirmed Sales amount in USD',
        delivery_rate: 'Delivery %'
      },
      stats_by_warehouse: {
        title: 'Stats by warehouse',
        visits: 'Visits',
        warehouse: 'Warehouse',
        active_products: 'Active Products',
        conversions: 'Orders (Leads)',
        sales_amount_usd: 'Sales amount in USD',
        confirmed_sales: 'Delivered orders',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        call_center_upsells: 'Call Center Upsells',
        delivery: 'Delivery %'
      },
      stats_by_offer: {
        title: 'Stats by offer',
        visits: 'Visits',
        offer: 'Offer',
        conversions: 'Orders (Leads)',
        payouts: 'Payouts',
        sales_amount_usd: 'Sales amount in USD',
        confirmed_sales: 'Delivered orders',
        confirmed_payouts: 'Confirmed Payouts',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        delivery: 'Delivery %'
      },
      stats_by_product: {
        title: 'Stats by product',
        visits: 'Visits',
        product: 'Product',
        orders: 'Orders (Leads)',
        sales_amount_usd: 'Sales amount in USD',
        delivered_orders: 'Delivered orders',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        delivery: 'Delivery %',
        upsell_percentage: 'Upsell %'
      },
      stats_by_manager: {
        title: 'Stats by manager',
        visits: 'Visits',
        manager: 'Manager',
        conversions: 'Orders (Leads)',
        payouts: 'Payouts',
        sales_amount_usd: 'Sales amount in USD',
        confirmed_sales: 'Delivered orders',
        confirmed_payouts: 'Confirmed Payouts',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        delivery: 'Delivery %'
      },
      stats_by_seller: {
        title: 'Stats by seller',
        visits: 'Visits',
        seller: 'Seller',
        conversions: 'Orders (Leads)',
        payouts: 'Payouts',
        sales_amount_usd: 'Sales amount in USD',
        confirmed_sales: 'Delivered orders',
        confirmed_payouts: 'Confirmed Payouts',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        delivery: 'Delivery %'
      },
      stats_by_call_agent: {
        title: 'Stats by call agent',
        visits: 'Visits',
        agent: 'Call agent',
        orders: 'Orders (Leads)',
        confirmed_leads: 'Confirmed Leads',
        delivered_orders: 'Delivered orders',
        upsells: 'Upsells',
        confirmation: 'Confirmation',
        delivery: 'Delivery %',
        upsell_percentage: 'Upsell %'
      }
    }
  },
  accounting_page: {
    filter: {
      offers: {
        all_option: 'All Offers'
      },
      countries: {
        all_option: 'All Countries'
      },
      sellers: {
        all_option: 'All sellers'
      },
      products: {
        all_option: 'All product'
      },
      call_agents: {
        all_option: 'All call agents'
      },
      by_period: {
        daily: 'Daily',
        monthly: 'Monthly'
      }
    },
    chart_tooltip: {
      date: 'Date: {v}',
      orders: 'Delivered Orders: {v}',
      total: 'Total: {v}',
      usdTotal: 'Usd Total: {v}',
      productCost: 'Product Cost: {v}',
      logisticCost: 'Logistics Cost: {v}',
      tax: 'Tax: {v}',
      totalCost: 'Total Cost: {v}',
      profit: 'Profit: {v}',
      toPayToNetwork: 'To Pay To Network: {v}'
    },
    tables: {
      total: 'Total',
      stats_by_country: {
        title: 'Stats by country',
        country: 'Country',
        confirmed_sales: 'Confirmed Sales',
        payout: 'Payout',
        product_cost: 'Product cost',
        fulfillment_shipping_return: 'Fulfillment, shipping and return',
        taxes: 'Taxes',
        total_cost: 'Total cost',
        to_pay_to_network: 'To pay to network',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        profit: 'Profit'
      },
      stats_by_warehouse: {
        title: 'Stats by warehouse',
        warehouse: 'Warehouse',
        confirmed_sales: 'Confirmed Sales',
        payout: 'Payout',
        product_cost: 'Product cost',
        fulfillment_shipping_return: 'Fulfillment, shipping and return',
        taxes: 'Taxes',
        total_cost: 'Total cost',
        to_pay_to_network: 'To pay to network',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        profit: 'Profit'
      },
      stats_by_offer: {
        title: 'Stats by offer',
        offer: 'Offer',
        confirmed_sales: 'Confirmed Sales',
        payout: 'Payout',
        product_cost: 'Product cost',
        fulfillment_shipping_return: 'Fulfillment, shipping and return',
        taxes: 'Taxes',
        total_cost: 'Total cost',
        to_pay_to_network: 'To pay to network',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        profit: 'Profit'
      },
      stats_by_product: {
        title: 'Stats by product',
        product: 'Product',
        confirmed_sales: 'Confirmed Sales',
        payout: 'Payout',
        product_cost: 'Product cost',
        fulfillment_shipping_return: 'Fulfillment, shipping and return',
        taxes: 'Taxes',
        total_cost: 'Total cost',
        to_pay_to_network: 'To pay to network',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        profit: 'Profit'
      },
      stats_by_manager: {
        title: 'Stats by manager',
        manager: 'Manager',
        confirmed_sales: 'Confirmed Sales',
        payout: 'Payout',
        product_cost: 'Product cost',
        fulfillment_shipping_return: 'Fulfillment, shipping and return',
        taxes: 'Taxes',
        total_cost: 'Total cost',
        to_pay_to_network: 'To pay to network',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        profit: 'Profit'
      },
      stats_by_seller: {
        title: 'Stats by seller',
        seller: 'Seller',
        confirmed_sales: 'Confirmed Sales',
        payout: 'Payout',
        product_cost: 'Product cost',
        fulfillment_shipping_return: 'Fulfillment, shipping and return',
        taxes: 'Taxes',
        total_cost: 'Total cost',
        to_pay_to_network: 'To pay to network',
        confirmed_sales_amount_usd: 'Confirmed Sales amount in USD',
        profit: 'Profit'
      }
    }
  },
  notification_page: {
    create_notification_btn: 'Create new Notification',
    form: {
      title: 'Create Notification',
      toggle_form: 'Click here to create a notification.',
      fields: {
        audience_users: {
          title: 'Users audience',
          placeholder: 'Select audience users'
        },
        title: {
          title: 'Notification title',
          placeholder: 'Type your notification title'
        },
        text: {
          title: 'Notification content',
          placeholder: 'Type your notification content'
        }
      },
      buttons: {
        create: 'Create notification'
      }
    }
  },
  tutorial_page: {
    create_tutorial_btn: 'create new tutorial',
    tutorial_not_found: 'No tutorials found.',
    category_form: {
      title: 'Create Tutorial',
      fields: {
        name: {
          title: 'Category',
          placeholder: 'Category name'
        }
      },
      buttons: {
        save: 'Save',
        cancel: 'Cancel'
      }
    },
    delete_dialog: {
      title: 'Delete {type}',
      text: 'Are you sure, you want to delete this {type} ?'
    },
    show_tutorial_dialog: {
      description: 'Description'
    },
    form: {
      title: 'Create Tutorial',
      toggle_form: 'Click here to create a tutorial.',
      fields: {
        category: {
          title: 'Tutorial Category',
          placeholder: 'Select Category'
        },
        category_choice_type: {
          options: {
            select_category: 'Select existing category',
            new_category: 'Create new category'
          }
        },
        new_category: {
          title: 'Tutorial New category',
          placeholder: 'Type new category'
        },
        title: {
          title: 'Tutorial Title',
          placeholder: 'Type tutorial title'
        },
        description: {
          title: 'Tutorial Description',
          placeholder: 'Type description'
        },
        video: {
          title: 'Tutorial Video',
          placeholder: 'Set tutorial video url'
        },
        on_startup: {
          title: 'Show on startup'
        }
      },
      buttons: {
        create: 'Create tutorial',
        duplicate: 'Duplicate tutorial',
        save: 'Save tutorial',
        edit_category: 'edit title',
        edit_tutorial: 'edit tutorial',
        delete_category: 'delete category',
        delete_tutorial: 'delete tutorial',
        publish: 'publish',
        un_publish: 'unpublish',
        cancel: 'Cancel'
      }
    }
  },
  support_page: {
    filter: {
      search: {
        placeholder: 'Filter tickets ...'
      },
      status: {
        all_option: 'All statuses'
      },
      user: {
        all_option: 'All users'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    faq_category_dialog: {
      title: 'Edit Category',
      form: {
        fields: {
          name: {
            title: 'Faq category name',
            placeholder: 'Type the faq category name'
          }
        },
        buttons: {
          save: 'Save',
          cancel: 'Cancel'
        }
      }
    },
    delete_dialog: {
      title: 'Delete {type}',
      text: 'Are you sure, you want to delete this {type} ?'
    },
    faq: {
      form: {
        create_faq_btn: 'create new faq',
        title: {
          create: 'Create faq',
          save: 'Save faq'
        },
        subtitle: 'Create a faq for your audience',
        fields: {
          category_choice: {
            options: {
              select_existing: 'Select existing category',
              create: 'Create new category'
            }
          },
          category: {
            title: 'Category',
            placeholder: 'Select category'
          },
          new_category: {
            title: 'New category',
            placeholder: 'create new category'
          },
          question: {
            title: 'Question',
            placeholder: 'Type a question'
          },
          answer: {
            title: 'Answer',
            placeholder: 'Type an answer to the question'
          }
        },
        buttons: {
          create: 'Create faq',
          save: 'Save faq',
          edit_category: 'Edit title',
          publish: 'Publish',
          un_publish: 'unPublish',
          delete_category: 'Delete category'
        }
      }
    },
    ticket: {
      created_by: '#{id} - created by {user_name}',
      last_message: 'last message : ',
      message_form: {
        fields: {
          message: {
            title: 'Message',
            placeholder: 'Type your message'
          }
        },
        buttons: {
          send: 'Send',
          close: 'Close'
        }
      },
      form: {
        create_ticket_btn: 'Create new ticket',
        title: 'Create Ticket',
        toggle_form: 'Click here to create a ticket',
        subtitle: 'Can’t find an answer ? Contact Admins here',
        fields: {
          type: {
            title: 'Issue type',
            placeholder: 'Select an issue type'
          },
          description: {
            title: 'Description',
            placeholder: 'Explain your request'
          }
        },
        buttons: {
          create: 'Create ticket'
        }
      }
    }
  },
  invoices_pending_orders_page: {
    pending_orders: 'Eligible Orders',
    cod_will_appear_on_delivered: 'COD orders will appear here when their status is on "Delivered", and they are not in a payout invoice.',
    prepaid_will_appear_on_shipped: 'Prepaid orders will appear here when their status is on "Shipped", and they are not in a payout invoice.',
    total_value: 'Total Payout value of selected orders is $ {value}',
    you_can_find_here: 'You can find here eligible orders that are ready for payout, you can select orders and click on Generate Payout if there Total value is $50 or more.',
    buttons: {
      generate_payout: 'Generate Payout',
      generate_remittance: 'Generate Remittance',
      generate_expenses: 'Generate Expenses',
      generate_commissions: 'Generate Commissions'
    },
    filter: {
      search: {
        placeholder: 'Filter pending orders ...'
      },
      status: {
        all_option: 'All payout statuses'
      },
      sellers: {
        all_option: 'All sellers'
      },
      warehouses: {
        all_option: 'All warehouses'
      },
      advertisers: {
        all_option: 'All advertisers'
      },
      remittance_status: {
        all_option: 'All remittance statuses'
      },
      expenses_status: {
        all_option: 'All expenses statuses'
      },
      commission_status: {
        all_option: 'All commission statuses'
      },
      payout_status: {
        all_option: 'All payout statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    table: {
      order_id: 'Order id',
      order_date: 'Order date',
      order_status: 'Order status',
      seller_name: 'Seller name',
      warehouse_name: 'Warehouse name',
      advertiser_name: 'Advertiser name',
      order_country: 'Order country',
      order_offer_name: 'Order offer name',
      payout_value: 'Payout value',
      payout_status: 'Payout status',
      payout_invoice_id: 'Payout invoice id',
      //affiliate_has_payment_info: 'Payment info',
      remittance_value: 'Remittance value',
      remittance_status: 'Remittance status',
      remittance_invoice_id: 'Remittance invoice id',
      expenses_value: 'Expenses value',
      expenses_status: 'Expenses status',
      expenses_invoice_id: 'Expenses invoice id',
      commission_value: 'Commission value',
      commission_status: 'Commission status',
      commission_invoice_id: 'Commission invoice id'
    }
  },
  invoices_referral_page: {
    table_card: {
      title: 'Referrals Invoices',
      subtitle: 'When your referred affiliates get orders and get paid for their commissions, we will show ' + 'you here their invoices and the commission you earned from their sales ($1 for each eligible order) .' + '<br>To generate a referral invoice and request a payment you should have accumulated a total of $50 ' + 'commissions or more from your referrals commissions. <br> ' + 'Every Monday we will process payments for your generated invoices of the previous week.',
      generate_payout_action: {
        text: 'Generate payout for {count} invoices',
        button_text: 'generate payout'
      },
      table: {
        headers: {
          invoice_id: 'Invoice id',
          date: 'Date',
          referrer: 'Referrer',
          generated_for: 'Generated for',
          referral_commission: 'Referral commission'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'Filter invoices...'
      },
      referrer: {
        placeholder: 'All referrers'
      },
      invoice_status: {
        placeholder: 'All statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    payout_invoices: {
      invoice_order: {
        title: 'Referred Invoice list',
        pdf_text: {
          file_name: 'Referrer payout invoice #{id}',
          pdf_header: 'Referrer referred invoices',
          invoice_details: 'Invoice details',
          payment_info: 'Payment info',
          invoice_orders: 'Invoice Orders',
          contact_email: 'Contact email: {email}',
          web_site: 'Website: {web_site}'
        },
        summary_info: {
          invoice_id: 'Invoice ID',
          date: 'Generated at',
          generated_by: 'Generated by',
          generated_for: 'Generated for',
          payment_method: 'Payment method',
          total_commission: 'Total network commission',
          total_payout: 'Total payout',
          status: 'Payment status',
          paid_at: 'Paid at',
          payment_id: 'Payment id'
        },
        payment_info: 'Payment Info',
        buttons: {
          close: 'Close',
          delete: 'Delete invoice',
          download_as_exel: 'Download as Excel',
          download_as_pdf: 'Download as PDF'
        },
        table: {
          order_id: 'Order id',
          order_date: 'Order date',
          order_offer_name: 'Order offer name',
          order_country_name: 'Order country name',
          order_confirmed_usd: 'Total sale in usd',
          order_commission: 'Network commission',
          order_payout: 'Order payout',
          order_remittance_status: 'Remittance status',
          order_status: 'Order Status',
          actions: 'Actions'
        }
      }
    }
  },
  [`invoices_${Invoice.PAYOUT_TYPE}_page`]: {
    total_paid_earnings: 'Total Paid Earnings',
    this_month: 'This Month',
    last_month: 'Last Month',
    this_year: 'This Year',
    last_year: 'Last Year',
    all_time: 'All Time',
    payout_invoices: {
      title: 'Payment Invoices',
      subtitle: {
        first_part: '<strong>To generate an invoice and request a payment you should have accumulated a total of $50 commissions or more from your eligible orders (Delivered orders)</strong>',
        second_part: 'Every Monday we will process payments for your generated invoices of the previous week. <br>' + 'We may edit your invoice to exclude some orders that are not yet eligible for payment, ' + 'and they will be available in the list of pending orders, and you can include it in your next invoice'
      },
      mark_selected: 'Mark selected {count} invoice (s) to paid',
      dialogs: {
        remove_order_dialog: {
          title: 'Delete order',
          content: 'Are you sure you want to delete this order from it\'s invoice ?'
        },
        remove_invoice_dialog: {
          title: 'Delete invoice',
          content: 'Are you sure you want to delete this invoice ?'
        }
      },
      form: {
        fields: {
          payment_id: {
            placeholder: 'Type you payment id'
          },
          payment_method: {
            options: {
              payoneer: 'Payoneer',
              back_transfer: 'Bank transfer'
            },
            placeholder: 'Select a payment method'
          }
        },
        buttons: {
          pay_invoices: 'Pay invoices'
        }
      },
      table: {
        invoice_id: 'Invoice id',
        invoice_generated_by: 'Generated by',
        invoice_generated_for: 'Generated for',
        date: 'Date',
        total: 'Total payout (Validated Payouts in USD)',
        payment_method: 'Payment method',
        status: 'Status',
        invoice_type: 'Invoice type',
        actions: 'Actions',
        payment_id: 'Payment id'
      },
      referrer_referrers_invoices: {
        title: 'Referrer referred invoices',
        table: {
          id: 'Invoice Id',
          date: 'Date',
          generatedFor: 'Generated For',
          totalPayout: 'Total payout',
          referrerCommission: 'Referrer commission'
        }
      },
      invoice_order: {
        title: 'Invoice order list',
        pdf_text: {
          file_name: 'Affiliate payouts invoice #{id}',
          pdf_header: 'Affiliate payouts invoice',
          invoice_details: 'Invoice details',
          payment_info: 'Payment info',
          invoice_orders: 'Invoice Orders',
          contact_email: 'Contact email: {email}',
          web_site: 'Website: {web_site}'
        },
        summary_info: {
          invoice_id: 'Invoice ID',
          date: 'Generated at',
          generated_by: 'Generated by',
          generated_for: 'Generated for',
          payment_method: 'Payment method',
          total_commission: 'Total network commission',
          total_payout: 'Total payout',
          status: 'Payment status',
          paid_at: 'Paid at',
          payment_id: 'Payment id'
        },
        payment_info: 'Payment Info',
        buttons: {
          close: 'Close',
          delete: 'Delete invoice',
          download_as_exel: 'Download as Excel',
          download_as_pdf: 'Download as PDF'
        },
        table: {
          order_id: 'Order id',
          order_date: 'Order date',
          order_offer_name: 'Order offer name',
          order_country_name: 'Order country name',
          order_confirmed_usd: 'Total sale in usd',
          order_commission: 'Network commission',
          order_payout: 'Order payout',
          order_remittance_status: 'Remittance status',
          order_status: 'Order Status',
          actions: 'Actions'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'Filter by invoice id'
      },
      seller: {
        all_option: 'All Sellers'
      },
      status: {
        all_option: 'All Statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    }
  },
  [`invoices_${Invoice.REMITTANCE_TYPE}_page`]: {
    total_paid_earnings: 'Total Paid Earnings',
    this_month: 'This Month',
    last_month: 'Last Month',
    this_year: 'This Year',
    last_year: 'Last Year',
    all_time: 'All Time',
    payout_invoices: {
      title: 'Payment Invoices',
      subtitle: {
        second_part: 'Every Monday we will process payments for your generated invoices of the previous week. <br>' + 'We may edit your invoice to exclude some orders that are not yet eligible for payment, ' + 'and they will be available in the list of pending orders, and you can include it in your next invoice'
      },
      mark_selected: 'Mark selected {count} invoice (s) to paid',
      dialogs: {
        remove_order_dialog: {
          title: 'Delete order',
          content: 'Are you sure you want to delete this order from it\'s invoice ?'
        },
        remove_invoice_dialog: {
          title: 'Delete invoice',
          content: 'Are you sure you want to delete this invoice ?'
        }
      },
      form: {
        fields: {
          payment_id: {
            placeholder: 'Type you payment id'
          },
          payment_method: {
            options: {
              payoneer: 'Payoneer',
              back_transfer: 'Bank transfer'
            },
            placeholder: 'Select a payment method'
          }
        },
        buttons: {
          pay_invoices: 'Pay invoices'
        }
      },
      table: {
        invoice_id: 'Invoice id',
        invoice_generated_by: 'Generated by',
        invoice_generated_for: 'Generated for',
        date: 'Date',
        total: 'Total remittance (Validated Sales in USD)',
        payment_method: 'Payment method',
        status: 'Status',
        type: 'Type',
        actions: 'Actions',
        payment_id: 'Payment id'
      },
      invoice_order: {
        title: 'Invoice order list',
        pdf_text: {
          file_name: 'Warehouse remittances invoice #{id}',
          pdf_header: 'Warehouse remittances invoice',
          invoice_details: 'Invoice details',
          payment_info: 'Payment info',
          invoice_orders: 'Invoice Orders',
          contact_email: 'Contact email: {email}',
          web_site: 'Website: {web_site}'
        },
        summary_info: {
          invoice_id: 'Invoice ID',
          total_commission: 'Total commission',
          date: 'Generated at',
          generated_by: 'Generated by',
          generated_for: 'Generated for',
          payment_method: 'Payment method',
          total_confirmed_sales_in_usd: 'Total confirmed sales in USD',
          total_network_commission: 'Total network commission',
          status: 'Status',
          paid_at: 'Paid at',
          payment_id: 'Payment id'
        },
        payment_info: 'Payment Info',
        buttons: {
          close: 'Close',
          delete: 'Delete invoice',
          download_as_exel: 'Download as Excel',
          download_as_pdf: 'Download as PDF'
        },
        table: {
          order_id: 'Order id',
          order_date: 'Order date',
          order_product_name: 'Order product name',
          order_country_name: 'Order country name',
          order_payout: 'Order payout',
          order_confirmed_usd: 'Confirmed sales in usd',
          order_commission: 'NetWork commission',
          order_status: 'Order Status',
          actions: 'Actions'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'Filter by invoice id'
      },
      warehouse: {
        all_option: 'All warehouse'
      },
      status: {
        all_option: 'All Statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    }
  },
  [`invoices_${Invoice.COMMISSION_TYPE}_page`]: {
    total_paid_earnings: 'Total Paid Earnings',
    this_month: 'This Month',
    last_month: 'Last Month',
    this_year: 'This Year',
    last_year: 'Last Year',
    all_time: 'All Time',
    payout_invoices: {
      title: 'Payment Invoices',
      subtitle: {
        second_part: 'Every Monday we will process payments for your generated invoices of the previous week. <br>' + 'We may edit your invoice to exclude some orders that are not yet eligible for payment, ' + 'and they will be available in the list of pending orders, and you can include it in your next invoice'
      },
      mark_selected: 'Mark selected {count} invoice (s) to paid',
      dialogs: {
        remove_order_dialog: {
          title: 'Delete order',
          content: 'Are you sure you want to delete this order from it\'s invoice ?'
        },
        remove_invoice_dialog: {
          title: 'Delete invoice',
          content: 'Are you sure you want to delete this invoice ?'
        }
      },
      form: {
        fields: {
          payment_id: {
            placeholder: 'Type you payment id'
          },
          payment_method: {
            options: {
              payoneer: 'Payoneer',
              back_transfer: 'Bank transfer'
            },
            placeholder: 'Select a payment method'
          }
        },
        buttons: {
          pay_invoices: 'Pay invoices'
        }
      },
      table: {
        invoice_id: 'Invoice id',
        invoice_generated_by: 'Generated by',
        invoice_generated_for: 'Generated for',
        date: 'Date',
        total: 'Total Adv Commissions (Validated Com in USD)',
        payment_method: 'Payment method',
        status: 'Status',
        type: 'Type',
        actions: 'Actions',
        payment_id: 'Payment id'
      },
      invoice_order: {
        title: 'Invoice order list',
        pdf_text: {
          file_name: 'Advertiser commissions invoice #{id}',
          pdf_header: 'Advertiser commissions invoice',
          invoice_details: 'Invoice details',
          payment_info: 'Payment info',
          invoice_orders: 'Invoice Orders',
          contact_email: 'Contact email: {email}',
          web_site: 'Website: {web_site}'
        },
        summary_info: {
          invoice_id: 'Invoice ID',
          total_commission: 'Total commission',
          date: 'Generated at',
          generated_by: 'Generated by',
          generated_for: 'Generated for',
          payment_method: 'Payment method',
          total_confirmed_sales_in_usd: 'Total commission to pay',
          total_network_commission: 'Total network commission',
          status: 'Status',
          paid_at: 'Paid at',
          payment_id: 'Payment id'
        },
        payment_info: 'Payment Info',
        buttons: {
          close: 'Close',
          delete: 'Delete invoice',
          download_as_exel: 'Download as Excel',
          download_as_pdf: 'Download as PDF'
        },
        table: {
          order_id: 'Order id',
          order_date: 'Order date',
          order_product_name: 'Order product name',
          order_country_name: 'Order country name',
          order_payout: 'Order payout',
          order_confirmed_usd: 'Confirmed sales in usd',
          order_commission: 'NetWork commission',
          order_status: 'Order status',
          order_total_commission: 'Total commission',
          actions: 'Actions'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'Filter by invoice id'
      },
      advertiser: {
        all_option: 'All advertisers'
      },
      status: {
        all_option: 'All Statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    }
  },
  [`invoices_${Invoice.EXPENSES_TYPE}_page`]: {
    total_paid_earnings: 'Total Paid Earnings',
    this_month: 'This Month',
    last_month: 'Last Month',
    this_year: 'This Year',
    last_year: 'Last Year',
    all_time: 'All Time',
    payout_invoices: {
      title: 'Payment Invoices',
      subtitle: {
        second_part: 'Every Monday we will process payments for your generated invoices of the previous week. <br>' + 'We may edit your invoice to exclude some orders that are not yet eligible for payment, ' + 'and they will be available in the list of pending orders, and you can include it in your next invoice'
      },
      mark_selected: 'Mark selected {count} invoice (s) to paid',
      dialogs: {
        remove_order_dialog: {
          title: 'Delete order',
          content: 'Are you sure you want to delete this order from it\'s invoice ?'
        },
        remove_invoice_dialog: {
          title: 'Delete invoice',
          content: 'Are you sure you want to delete this invoice ?'
        }
      },
      form: {
        fields: {
          payment_id: {
            placeholder: 'Type you payment id'
          },
          payment_method: {
            options: {
              payoneer: 'Payoneer',
              back_transfer: 'Bank transfer'
            },
            placeholder: 'Select a payment method'
          }
        },
        buttons: {
          pay_invoices: 'Pay invoices'
        }
      },
      table: {
        invoice_id: 'Invoice id',
        invoice_generated_by: 'Generated by',
        invoice_generated_for: 'Generated for',
        date: 'Date',
        total: 'Total Expenses (Validated Expenses in USD)',
        payment_method: 'Payment method',
        status: 'Status',
        type: 'Type',
        actions: 'Actions',
        payment_id: 'Payment id'
      },
      invoice_order: {
        title: 'Invoice order list',
        pdf_text: {
          file_name: 'Warehouse expenses invoice #{id}',
          pdf_header: 'Warehouse expenses invoice',
          invoice_details: 'Invoice details',
          payment_info: 'Payment info',
          invoice_orders: 'Invoice Orders',
          contact_email: 'Contact email: {email}',
          web_site: 'Website: {web_site}'
        },
        summary_info: {
          invoice_id: 'Invoice ID',
          total_commission: 'Total commission',
          date: 'Generated at',
          generated_by: 'Generated by',
          generated_for: 'Generated for',
          payment_method: 'Payment method',
          total_confirmed_sales_in_usd: 'Total confirmed sales in USD',
          total_network_commission: 'Total network commission',
          status: 'Status',
          paid_at: 'Paid at',
          payment_id: 'Payment id'
        },
        payment_info: 'Payment Info',
        buttons: {
          close: 'Close',
          delete: 'Delete invoice',
          download_as_exel: 'Download as Excel',
          download_as_pdf: 'Download as PDF'
        },
        table: {
          order_id: 'Order id',
          order_date: 'Order date',
          order_product_name: 'Order product name',
          order_country_name: 'Order country name',
          order_payout: 'Order payout',
          order_confirmed_usd: 'Confirmed sales in usd',
          order_commission: 'NetWork commission',
          order_status: 'Order Status',
          actions: 'Actions'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'Filter by invoice id'
      },
      warehouse: {
        all_option: 'All warehouse'
      },
      status: {
        all_option: 'All Statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    }
  },
  product_page,
  inventory_overview_page: {
    day: 'day(s)',
    no_stock_available: 'No stock available',
    stock_available: 'Stock available',
    will_empty_out_soon: 'Will empty out soon',
    filter: {
      search: {
        placeholder: 'Filter products ...'
      },
      country: {
        placeholder: 'All countries'
      },
      warehouse: {
        placeholder: 'All warehouses'
      },
      product: {
        placeholder: 'All products'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    table: {
      sku: 'Product SKU',
      product_name: 'Product name',
      country: 'Country',
      warehouse: 'Warehouse',
      available_quantity: 'Available Quantity',
      last_daily_sales: 'Last daily sales',
      last_weekly_sales: 'Last weekly sales',
      out_of_stock: 'Out of stock in'
    }
  },
  call_center_page: {
    create_call_agent_btn: 'Create new call agent',
    filter: {
      search: {
        placeholder: 'Filter call agents'
      },
      country: {
        all_option: 'All countries'
      },
      warehouse: {
        all_option: 'All warehouses'
      }
    },
    form: {
      toggle_form: 'Click here to create a call agent',
      no_result_matching: 'No results matching',
      create_call_agent: {
        title: 'Create Call Agent',
        subtitle: 'Create new call agent'
      },
      update_call_agent: {
        title: 'Update Call Agent',
        subtitle: 'Update call agent'
      },
      buttons: {
        create: 'Create call agent',
        save: 'Save call agent',
        cancel: 'Cancel'
      },
      fields: {
        full_name: {
          title: 'Full name',
          placeholder: 'Type the full name'
        },
        company_name: {
          title: 'Company name',
          placeholder: 'Type the company name'
        },
        country: {
          title: 'Country',
          placeholder: 'Select a country'
        },
        user_name: {
          title: 'Username',
          placeholder: 'Type the username'
        },
        email: {
          title: 'Email',
          placeholder: 'example@example.com'
        },
        phone: {
          title: 'Phone',
          placeholder: 'Type the phone number'
        },
        password: {
          title: 'Password',
          placeholder: 'Type the password'
        },
        confirmation: {
          title: 'Password confirmation',
          placeholder: 'Repeat the password'
        },
        language: {
          title: 'Language',
          placeholder: 'Select the speaking language'
        },
        warehouse: {
          title: 'Warehouse',
          placeholder: 'Select the warehouse'
        },
        assigned_products: {
          title: 'Assigned products',
          placeholder: 'Select the assigned products'
        }
      }
    },
    table_card: {
      title: 'Call Agents',
      subtitle: 'Manage call agents',
      set_selected_status_to: 'Set Status for {count} selected call agents to : ',
      change_assigned_for_selected: 'Change assigned products for {count} selected call agents to:',
      buttons: {
        apply: 'Apply',
        assigned_products: 'Assign products'
      },
      fields: {
        assigned_products: {
          content_text: '(+{n} others)',
          select_all: 'Select all',
          no_products: 'No products'
        }
      },
      table: {
        creation_date: 'Creation date',
        warehouse: 'Warehouse',
        Language_used: 'Language used',
        name: 'Name',
        contact_name: 'Contact name',
        contact_details: 'Contact details',
        country: 'Country',
        assigned_products: 'Assigned products',
        status: 'Status',
        actions: 'Actions'
      }
    }
  },
  warehouse_page: warehouses_page,
  offer_request_page: {
    filter: {
      offer: {
        all_option: 'All offers'
      },
      influencer: {
        all_option: 'All influencers'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    table_card: {
      set_selected_status_to: 'Set status for {count} requests to : ',
      buttons: {
        apply: 'Apply'
      },
      table: {
        request_date: 'Request date',
        influencer: 'Influencer',
        offer: 'Offer',
        status: 'Status',
        actions: 'Actions'
      },
      influencer_Details: {
        title: 'Influencer Details',
        buttons: {
          save: 'Save',
          cancel: 'Cancel'
        }
      }
    },
    dialogs: {
      delete: {
        title: 'Delete offer request',
        content: 'Are you sure, you want to delete this offer request ?'
      }
    }
  },
  activity_logs_page: {
    filter: {
      search: {
        placeholder: 'Filter activities by user ...'
      }
    },
    before_change: 'Before change',
    after_change: 'After change',
    table: {
      field_name: 'Field Name',
      field_content: 'Field Content'
    }
  },
  advertiser_page: {
    create_advertiser_btn: 'Create new advertiser',
    filter: {
      search: {
        placeholder: 'Filter advertiser ...'
      },
      status: {
        all_option: 'All statuses'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    form: {
      toggle_form: 'Click here to create an advertiser.',
      create_advertiser: {
        title: 'Create Advertiser',
        subtitle: 'Create new advertiser'
      },
      update_advertiser: {
        title: 'Update advertiser',
        subtitle: 'Update advertiser'
      },
      fields: {
        warehouse: {
          title: 'Warehouse',
          placeholder: 'Select the advertiser warehouse'
        },
        country: {
          title: 'Country',
          placeholder: 'Select the advertiser country'
        },
        user_name: {
          title: 'Username',
          placeholder: 'Type the username'
        },
        contact_name: {
          title: 'Contact name',
          placeholder: 'Type the contact name'
        },
        email: {
          title: 'Email',
          placeholder: 'example@example.com'
        },
        password: {
          title: 'Password',
          placeholder: 'Type the password'
        },
        confirmation: {
          title: 'Password confirmation',
          placeholder: 'Type the password confirmation'
        },
        phone: {
          title: 'Phone',
          placeholder: 'Type the phone number'
        },
        skype: {
          title: 'Skype',
          placeholder: 'Type the skype id'
        }
      },
      buttons: {
        create: 'Create advertiser',
        duplicate: 'Duplicate advertiser',
        save: 'Save advertiser',
        cancel: 'Cancel'
      }
    },
    table_card: {
      set_selected_status_to: 'Set status for {count} requests to : ',
      buttons: {
        apply: 'Apply'
      },
      table: {
        creation_date: 'Creation date',
        advertiser_type: 'Advertiser type',
        advertiser_name: 'Advertiser name',
        contact_name: 'Contact name',
        contact_details: 'Contact details',
        status: 'Status',
        action: 'Actions'
      }
    }
  },
  seller_page: seller_page,
  referral_program_page,
  user_page: {
    filter: {
      search: {
        placeholder: 'Filter sellers ...'
      },
      role: {
        all_option: 'All roles'
      },
      status: {
        all_option: 'All statuses'
      },
      country: {
        all_option: 'All countries'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      },
      logged_status: {
        last_logged_in: 'Last logged in',
        first_logged_in: 'First logged in'
      }
    },
    table_card: {
      tabs: {
        manage_user: {
          tab_title: 'Manage users',
          set_selected_status_to: 'Set status for {count} selected users to : ',
          buttons: {
            apply: 'Apply'
          },
          more_info: {
            country: 'Country',
            skype_id: 'Skype id',
            company_name: 'Company name',
            level: 'Level',
            experience_description: 'Experience description',
            seller_status: 'Seller status',
            subscribed_to_news_letter: 'Subscribed to news letter ?',
            youtube_profile: 'Youtube profile',
            instagram_profile: 'Instagram profile'
          },
          table: {
            more_info: 'More info',
            sign_up_date: 'Signup date',
            role: 'Role',
            user_name: 'Username',
            full_name: 'Full name',
            contact_details: 'Contact details',
            country: 'Country',
            last_month_confirmed_sales: 'Last 30 days confirmed sales',
            status: 'Status',
            actions: 'Actions'
          }
        },
        manage_role: {
          tab_title: 'Manage roles',
          form: {
            fields: {
              roles: {
                title: 'Roles',
                placeholder: 'Select roles'
              },
              permissions: {
                title: 'Permissions',
                placeholder: 'Select permissions'
              }
            }
          },
          buttons: {
            update_roles: {
              text: 'update roles'
            }
          }
        },
        manage_plan: {
          tab_title: 'Manage plan',
          form: {
            fields: {
              plans: {
                title: 'Plans',
                placeholder: 'Select plan'
              },
              permissions: {
                title: 'Permissions',
                placeholder: 'Select permissions'
              }
            }
          },
          buttons: {
            update_plans: {
              text: 'update plan'
            }
          }
        }
      }
    },
    form: {
      create_user_btn: 'create new user',
      toggle_form: 'Click here to create a user.',
      the_user_level_is: 'The user level is {level}',
      create_user: {
        title: 'Create User',
        subtitle: 'Create new user'
      },
      update_user: {
        title: 'Update User',
        subtitle: 'Update user'
      },
      fields: {
        full_name: {
          title: 'Full name',
          placeholder: 'Type the full name'
        },
        user_name: {
          title: 'Pseudo Name',
          placeholder: 'Type your pseudo name (username)'
        },
        email: {
          title: 'Email',
          placeholder: 'example@example.com'
        },
        password: {
          title: 'Password',
          placeholder: 'Type the password'
        },
        confirmation: {
          title: 'Password confirmation',
          placeholder: 'Type the password confirmation'
        },
        phone: {
          title: 'Phone',
          placeholder: 'Type the phone number'
        },
        skype: {
          title: 'Skype',
          placeholder: 'Type the skype id'
        },
        company: {
          title: 'Company',
          placeholder: 'Type the company name'
        },
        country: {
          title: 'Country',
          all_option: 'Select country',
          placeholder: 'Type Country name'
        },
        role: {
          title: 'Role',
          placeholder: 'Select the user role'
        },
        permission: {
          title: 'Permissions',
          hint: 'Select permissions carefully',
          placeholder: 'Select the user permissions'
        },
        plan: {
          title: 'Select plan',
          free_trial: {
            title: 'Eligible to free trial'
          },
          current_plan: {
            title: 'Current plan'
          },
          next_plan: {
            title: 'Next Cycle Plan'
          },
          plan_period: {
            title: 'Period expiration date'
          }
        },
        status: {
          title: 'Status'
        },
        seller_status: {
          title: 'Seller status'
        },
        level: {
          title: 'Level',
          placeholder: 'Select the user level'
        },
        subscribed_to_news_letter: {
          title: 'Subscribe to newsletter'
        }
      },
      buttons: {
        create: 'Create user',
        save: 'Save user',
        duplicate: 'Duplicate user',
        cancel: 'Cancel'
      }
    }
  },
  account_settings: {
    email_not_verified: {
      text: 'Your email is not verified yet, click the button to send a new verification request.',
      button: 'Verify'
    }
  },
  library_page: {
    images: 'Images',
    videos: 'Videos',
    dialog: {
      title: 'Delete image',
      content: 'Are you sure you want to delete this image?'
    }
  },
  notifications: {
    notifications: 'Notifications',
    view_notifications: 'View notifications',
    no_notification_found: 'No notifications found.'
  },
  invoice_statuses: {
    [Invoice.PAID_STATUS]: startCase(Invoice.PAID_STATUS),
    [Invoice.PENDING_STATUS]: startCase(Invoice.PENDING_STATUS),
    [Invoice.NOT_APPLICABLE_STATUS]: 'N/A'
  },
  user_statuses: {
    [User.ACTIVE_STATUS]: startCase(User.ACTIVE_STATUS),
    [User.INACTIVE_STATUS]: startCase(User.INACTIVE_STATUS),
    [User.SUSPENDED_STATUS]: startCase(User.SUSPENDED_STATUS)
  },
  stripe_modes: {
    [Stripe.TEST_MODE]: startCase(Stripe.TEST_MODE),
    [Stripe.LIVE_MODE]: startCase(Stripe.LIVE_MODE)
  },
  invoice_types: {
    [Invoice.EXPENSES_TYPE]: startCase(Invoice.EXPENSES_TYPE),
    [Invoice.CHARGES_TYPE]: startCase(Invoice.CHARGES_TYPE)
  },
  invoice_payment_types: {
    [Invoice.REFERRER_PAYOUT_TYPE]: startCase(Invoice.REFERRER_PAYOUT_TYPE),
    [Invoice.PAYOUT_TYPE]: startCase(Invoice.PAYOUT_TYPE)
  },
  offer_country_select_types: {
    [Offer.MULTIPLE_COUNTRY_SELECT_TYPE]: 'Select Countries',
    [Offer.SAME_COUNTRY_SELECT_TYPE]: 'Same as inventory',
    [Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE]: startCase(Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE)
  },
  warehouse_country_select_types: {
    [Warehouse.MULTIPLE_COUNTRY_SELECT_TYPE]: startCase(Warehouse.MULTIPLE_COUNTRY_SELECT_TYPE),
    [Warehouse.WORLD_WIDE_COUNTRY_SELECT_TYPE]: startCase(Warehouse.WORLD_WIDE_COUNTRY_SELECT_TYPE)
  },
  role: {
    [Role.WAREHOUSE_ROLE]: startCase(Role.WAREHOUSE_ROLE),
    [Role.INFLUENCER_ROLE]: startCase(Role.INFLUENCER_ROLE),
    [Role.SELLER_ROLE]: startCase(Role.SELLER_ROLE),
    [Role.AFFILIATE_ROLE]: 'Affiliate',
    [Role.ADMIN_ROLE]: startCase(Role.ADMIN_ROLE),
    [Role.MANAGER_ROLE]: startCase(Role.MANAGER_ROLE),
    [Role.CALL_AGENT_ROLE]: startCase(Role.CALL_AGENT_ROLE),
    [Role.ADVERTISER_ROLE]: startCase(Role.ADVERTISER_ROLE)
  },
  seller_statuses: {
    [User.STANDARD_SELLER_STATUS]: startCase(User.STANDARD_SELLER_STATUS),
    [User.EXCLUSIVE_SELLER_STATUS]: startCase(User.EXCLUSIVE_SELLER_STATUS),
    [User.PRIVATE_SELLER_STATUS]: startCase(User.PRIVATE_SELLER_STATUS),
    [User.TEST_SELLER_STATUS]: startCase(User.TEST_SELLER_STATUS)
  },
  product_statuses: {
    [Product.ACTIVE_STATUS]: startCase(Product.ACTIVE_STATUS),
    [Product.DRAFT_STATUS]: startCase(Product.DRAFT_STATUS)
  },
  advertiser_types: {
    [User.HYBRID_ADVERTISER_TYPE]: startCase(User.HYBRID_ADVERTISER_TYPE),
    [User.INDEPENDENT_ADVERTISER_TYPE]: startCase(User.INDEPENDENT_ADVERTISER_TYPE),
    [User.SOLO_ADVERTISER_TYPE]: startCase(User.SOLO_ADVERTISER_TYPE)
  },
  inventory_types: {
    [Inventory.PRIVATE_TYPE]: startCase(Inventory.PRIVATE_TYPE),
    [Inventory.OUTSOURCED_TYPE]: startCase(Inventory.OUTSOURCED_TYPE)
  },
  ticket_statuses: {
    [Ticket.CLOSED_STATUS]: startCase(Ticket.CLOSED_STATUS),
    [Ticket.CREATED_STATUS]: startCase(Ticket.CREATED_STATUS),
    [Ticket.UPDATED_STATUS]: startCase(Ticket.UPDATED_STATUS)
  },
  referred_from: {
    [User.REFERRED_FROM_YOUTUBE]: startCase(User.REFERRED_FROM_YOUTUBE),
    [User.REFERRED_FROM_FACEBOOK]: startCase(User.REFERRED_FROM_FACEBOOK),
    [User.REFERRED_FROM_INSTAGRAM]: startCase(User.REFERRED_FROM_INSTAGRAM),
    [User.REFERRED_FROM_GOOGLE]: startCase(User.REFERRED_FROM_GOOGLE),
    [User.REFERRED_FROM_FRIEND]: startCase(User.REFERRED_FROM_FRIEND),
    [User.REFERRED_FROM_OTHER]: startCase(User.REFERRED_FROM_OTHER)
  },
  sale_page_default_currency_type: {
    [SalePage.OFFER_COUNTRY_DEFAULT_CURRENCY]: startCase(SalePage.INVENTORY_COUNTRY_DEFAULT_CURRENCY),
    [SalePage.CUSTOM_CURRENCY]: startCase(SalePage.CUSTOM_CURRENCY)
  },
  ticket_types: {
    [Ticket.FEATURE_REQUEST_TYPE]: startCase(Ticket.FEATURE_REQUEST_TYPE),
    [Ticket.HOW_TO_TYPE]: startCase(Ticket.HOW_TO_TYPE),
    [Ticket.PAYMENT_TYPE]: startCase(Ticket.PAYMENT_TYPE),
    [Ticket.TECHNICAL_PROBLEM_TYPE]: startCase(Ticket.TECHNICAL_PROBLEM_TYPE)
  },
  store_language_types: {
    [Store.ONE_LANGUAGE_TYPE]: startCase(Store.ONE_LANGUAGE_TYPE),
    [Store.MULTIPLE_LANGUAGE_TYPE]: startCase(Store.MULTIPLE_LANGUAGE_TYPE)
  },
  offer_payment_types: {
    [Offer.COD_PAYMENT_TYPE]: startCase(Offer.COD_PAYMENT_TYPE),
    [Offer.CARD_PAYMENT_TYPE]: startCase(Offer.CARD_PAYMENT_TYPE),
    [Offer.CARD_PAYMENT_TYPE_ALTERNATIVE]: startCase(Offer.CARD_PAYMENT_TYPE_ALTERNATIVE)
  },
  checkout_form_setting_methods: {
    [CheckoutFormSettings.COD_PAYMENT_METHOD]: startCase(CheckoutFormSettings.COD_PAYMENT_METHOD),
    [CheckoutFormSettings.CARD_PAYMENT_METHOD]: 'Online Payment'
  },
  offer_statuses: {
    [Offer.ACTIVE_STATUS]: startCase(Offer.ACTIVE_STATUS),
    [Offer.DRAFT_STATUS]: startCase(Offer.DRAFT_STATUS),
    [Offer.PAUSED_STATUS]: startCase(Offer.PAUSED_STATUS)
  },
  offer_commission_type: {
    [Offer.CONFIRMED_COMMISSION_TYPE]: 'For Confirmed',
    [Offer.DELIVERED_COMMISSION_TYPE]: 'For Delivered'
  },
  sale_page_payment_types: {
    [SalePage.COD_PAYMENT_TYPE]: startCase(SalePage.COD_PAYMENT_TYPE),
    [SalePage.CARD_PAYMENT_TYPE]: startCase(SalePage.CARD_PAYMENT_TYPE)
  },
  sale_page_statuses: {
    [SalePage.ACTIVE_STATUS]: startCase(SalePage.ACTIVE_STATUS),
    [SalePage.DRAFT_STATUS]: startCase(SalePage.DRAFT_STATUS),
    [SalePage.PAUSED_STATUS]: startCase(SalePage.PAUSED_STATUS)
  },
  order_google_sheet_orders_from: {
    [GoogleSheet.FROM_ANY_WHERE]: startCase(GoogleSheet.FROM_ANY_WHERE),
    [GoogleSheet.FROM_PRODUCT]: startCase(GoogleSheet.FROM_PRODUCT),
    [GoogleSheet.FROM_WAREHOUSE]: startCase(GoogleSheet.FROM_WAREHOUSE),
    [GoogleSheet.FROM_SALE_PAGE]: startCase(GoogleSheet.FROM_SALE_PAGE),
    [GoogleSheet.FROM_STORE]: startCase(GoogleSheet.FROM_STORE)
  },
  ecommerce_sdk_account_statuses: {
    [ECommerceSdkAccount.ACTIVE_STATUS]: startCase(ECommerceSdkAccount.ACTIVE_STATUS),
    [ECommerceSdkAccount.INACTIVE_STATUS]: startCase(ECommerceSdkAccount.INACTIVE_STATUS)
  },
  pre_sell_page_statuses: {
    [PreSellPage.ACTIVE_STATUS]: startCase(PreSellPage.ACTIVE_STATUS),
    [PreSellPage.INACTIVE_STATUS]: startCase(PreSellPage.INACTIVE_STATUS)
  },
  product_variation_statuses: {
    [ProductVariation.ACTIVE_STATUS]: startCase(ProductVariation.ACTIVE_STATUS),
    [ProductVariation.INACTIVE_STATUS]: startCase(ProductVariation.INACTIVE_STATUS)
  },
  offer_types: {
    [Offer.STANDARD_TYPE]: startCase(Offer.STANDARD_TYPE),
    [Offer.EXCLUSIVE_TYPE]: startCase(Offer.EXCLUSIVE_TYPE),
    [Offer.VIP_TYPE]: startCase(Offer.VIP_TYPE),
    [Offer.TEST_TYPE]: startCase(Offer.TEST_TYPE),
    [Offer.PRIVATE_TYPE]: startCase(Offer.PRIVATE_TYPE)
  },
  order_call_statuses: {
    [Order.NEW_CALL_STATUS]: 'New',
    [Order.CALL_STATUS]: {
      1: 'Call 1',
      2: 'Call 2',
      3: 'Call 3',
      4: 'Call 4',
      5: 'Call 5',
      6: 'Call 6',
      7: 'Call 7',
      8: 'Call 8',
      9: 'Call 9',
      10: 'Call 10',
      11: 'Call 11',
      12: 'Call 12',
      13: 'Call 13',
      14: 'Call 14'
    },
    [Order.NO_REPLY_STATUS]: 'No reply',
    [Order.EXPIRED_STATUS]: 'Expired',
    [Order.SCHEDULED_STATUS]: 'Scheduled',
    [Order.WRONG_NUMBER_STATUS]: 'Wrong number',
    [Order.WRONG_COUNTRY_STATUS]: 'Wrong country'
  },
  offer_levels: {
    auto: 'Auto',
    level_1: 'Level 1',
    level_2: 'Level 2',
    level_3: 'Level 3',
    vip: 'Vip'
  },
  sale_page_option_type: {
    [Option.NORMAL_OFFER_TYPE]: startCase(Option.NORMAL_OFFER_TYPE),
    [Option.WARNING_OFFER_TYPE]: startCase(Option.WARNING_OFFER_TYPE)
  },
  subscription_plans: {
    [SubscriptionPlan.BASIC_PLAN_NAME]: startCase(SubscriptionPlan.BASIC_PLAN_NAME),
    [SubscriptionPlan.ADVANCED_PLAN_NAME]: startCase(SubscriptionPlan.ADVANCED_PLAN_NAME),
    [SubscriptionPlan.BUSINESS_PLAN_NAME]: startCase(SubscriptionPlan.BUSINESS_PLAN_NAME),
    [SubscriptionPlan.FULL_ACCESS_PLAN_NAME]: startCase(SubscriptionPlan.FULL_ACCESS_PLAN_NAME)
  },
  order_statuses: {
    all: 'All',
    [Order.RETURNED_STATUS]: startCase(Order.RETURNED_STATUS),
    [Order.DELIVERED_STATUS]: startCase(Order.DELIVERED_STATUS),
    [Order.SHIPPED_STATUS]: startCase(Order.SHIPPED_STATUS),
    [Order.CANCELED_STATUS]: startCase(Order.CANCELED_STATUS),
    [Order.CONFIRMED_STATUS]: startCase(Order.CONFIRMED_STATUS),
    [Order.PROCESSING_STATUS]: startCase(Order.PROCESSING_STATUS),
    [Order.PENDING_STATUS]: startCase(Order.PENDING_STATUS),
    [Order.NO_ANSWER_STATUS]: startCase(Order.NO_ANSWER_STATUS)
  },
  insert_orders_from: {
    [GoogleSheet.FROM_ANY_WHERE]: 'From any order in my account',
    [GoogleSheet.FROM_STORE]: startCase(GoogleSheet.FROM_STORE) + '(s)',
    [GoogleSheet.FROM_PRODUCT]: startCase(GoogleSheet.FROM_PRODUCT) + '(s)',
    [GoogleSheet.FROM_WAREHOUSE]: startCase(GoogleSheet.FROM_WAREHOUSE) + '(s)',
    [GoogleSheet.FROM_SALE_PAGE]: startCase(GoogleSheet.FROM_SALE_PAGE) + '(s)'
  },
  scrapper_platforms: {
    [ProductScraper.ALIEXPRESS_PLATFORM]: startCase(ProductScraper.ALIEXPRESS_PLATFORM),
    [ProductScraper.AMAZON_PLATFORM]: startCase(ProductScraper.AMAZON_PLATFORM),
    [ProductScraper.SHOPIFY_PLATFORM]: startCase(ProductScraper.SHOPIFY_PLATFORM)
  },
  user_id_verification_statuses: {
    [UserIdVerification.VERIFICATION_PENDING_STATUS]: startCase(UserIdVerification.VERIFICATION_PENDING_STATUS),
    [UserIdVerification.VERIFICATION_REJECTED_STATUS]: startCase(UserIdVerification.VERIFICATION_REJECTED_STATUS),
    [UserIdVerification.VERIFICATION_VERIFIED_STATUS]: startCase(UserIdVerification.VERIFICATION_VERIFIED_STATUS)
  },
  google_sheet_statuses: {
    [GoogleSheet.ACTIVE_STATUS]: startCase(GoogleSheet.ACTIVE_STATUS),
    [GoogleSheet.INACTIVE_STATUS]: startCase(GoogleSheet.INACTIVE_STATUS)
  },
  notification_types: {
    [Notification.FEATURE_TYPE]: startCase(Notification.FEATURE_TYPE),
    [Notification.INVOICE_TYPE]: startCase(Notification.INVOICE_TYPE),
    [Notification.OFFER_TYPE]: startCase(Notification.OFFER_TYPE),
    [Notification.PRODUCT_TYPE]: startCase(Notification.PRODUCT_TYPE),
    [Notification.SUPPORT_TYPE]: startCase(Notification.SUPPORT_TYPE),
    [Notification.OTHER_TYPE]: startCase(Notification.OTHER_TYPE)
  },
  store_page: {
    languages: {
      [StorePage.ARABIC_LANG_SHORT]: 'Arabic',
      [StorePage.ENGLISH_LANG_SHORT]: 'English',
      [StorePage.FRENCH_LANG_SHORT]: 'French',
      [StorePage.ITALY_LANG_SHORT]: 'Italian',
      [StorePage.SPANISH_LANG_SHORT]: 'Spanish'
    },
    types: {
      [StorePage.HOME_PAGE]: startCase(StorePage.HOME_PAGE),
      [StorePage.FAQ_PAGE]: startCase(StorePage.FAQ_PAGE),
      [StorePage.CONTACT_PAGE]: startCase(StorePage.CONTACT_PAGE),
      [StorePage.PRODUCT_PAGE]: startCase(StorePage.PRODUCT_PAGE),
      [StorePage.ABOUT_PAGE]: startCase(StorePage.ABOUT_PAGE),
      [StorePage.SHIPPING_AND_RETURN_PAGE]: startCase(StorePage.SHIPPING_AND_RETURN_PAGE),
      [StorePage.SERVICE_TERMS_PAGE]: startCase(StorePage.SERVICE_TERMS_PAGE),
      [StorePage.PRIVACY_POLICY_PAGE]: startCase(StorePage.PRIVACY_POLICY_PAGE),
      [StorePage.REFUND_POLICY_PAGE]: startCase(StorePage.REFUND_POLICY_PAGE)
    }
  },
  user_verification_statuses: {
    [UserIdVerification.VERIFICATION_PENDING_STATUS]: startCase(UserIdVerification.VERIFICATION_PENDING_STATUS),
    [UserIdVerification.VERIFICATION_VERIFIED_STATUS]: startCase(UserIdVerification.VERIFICATION_VERIFIED_STATUS),
    [UserIdVerification.VERIFICATION_REJECTED_STATUS]: startCase(UserIdVerification.VERIFICATION_REJECTED_STATUS)
  },
  sale_page_checkout_length: {
    [SalePage.SHORT_CHECKOUT]: 'Short Form',
    [SalePage.LONG_CHECKOUT]: 'Long Form',
    [SalePage.CUSTOM_CHECKOUT]: 'Custom Form'
  },
  domain_types: {
    [Store.GENERAL_TYPE]: Store.GENERAL_TYPE,
    [Store.BRAND_TYPE]: [Store.BRAND_TYPE, '( One product store )'].join(' ')
  },
  sale_page_block_types: {
    main: 'Visible on page',
    home: 'Home',
    cross_sell_1: 'Cross sell 1'
  },
  sale_page_block_images_alignment: {
    left: 'Left',
    right: 'Right',
    center: 'Center'
  },
  languages: {
    ar: 'Arabic',
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    it: 'Italy'
  },
  generic_text: {
    ticket_notification_title: 'New Ticket Message',
    ticket_notification_description: 'There is a new ticket update, please check it <a class="font-weight-bold" href="/support/ticket">here</a>'
  },
  filter: {
    offer: {
      search: {
        placeholder: 'Filter offers'
      },
      country: {}
    }
  },
  form: {
    here: 'here',
    login: {
      user_name_or_email: 'User email',
      user_password: 'User password',
      login: 'Login',
      forget_password: 'Forgot password ? Request it',
      dont_have_account: 'Don\'t have an account ? Signup'
    },
    password_request: {
      user_email: 'User email',
      back_to_login: 'Back to Login',
      request_new_password: 'Request new password'
    },
    register: {
      sign_up_as_affiliate: 'Signup as Affiliate or Influencer ? Please select :',
      before_sign_up_text: 'Select a plan and add your info to create your online store.',
      agree_to_terms_and_services: {
        part_one: 'I agree to',
        part_two: 'Terms',
        part_three: 'and',
        part_four: 'Privacy policy'
      },
      receive_email_news_letters: 'Receive emails about new offers and updates',
      do_you_have_account: 'You have an account ? Login',
      sign_up: 'Sign up',
      user_social_media_profile: {
        title: 'Instagram, Tiktok or snapchat',
        placeholder: 'Social media link/name'
      },
      user_type: {
        options: {
          [Role.SELLER_ROLE]: 'Affiliate',
          [Role.INFLUENCER_ROLE]: startCase(Role.INFLUENCER_ROLE)
        }
      },
      subscription_plan: {
        title: 'Subscription Plan',
        options: {
          [SubscriptionPlan.BASIC_PLAN_NAME]: {
            text: startCase(SubscriptionPlan.BASIC_PLAN_NAME),
            price: '<span>0$/m</span> &nbsp; <span style="text-decoration: line-through; font-size: 12px; color: grey">19.99$/m</span>',
            features: {
              title: 'Features',
              content: ['1 Store, 1 Domain', 'Unlimited Products', 'Unlimited Sale Pages', 'Unlimited Orders', '0% Transactions Fees', 'Basic Statistics', 'Basic Apps', 'Ticket Support', 'No Team Members', 'No External API', 'No AI Content Generation']
            }
          },
          [SubscriptionPlan.ADVANCED_PLAN_NAME]: {
            text: startCase(SubscriptionPlan.ADVANCED_PLAN_NAME),
            price: '<span>9.99$/m</span> &nbsp; <span style="text-decoration: line-through; font-size: 12px; color: grey">29.99$/m</span>',
            features: {
              title: 'Features',
              content: ['2 Stores, 2 Domains', 'Unlimited Products', 'Unlimited Sale Pages', 'Unlimited Orders', '0% Transactions Fees', 'Advanced Statistics', 'Advanced Apps', 'Chat Support', 'Team Members (2)', 'External API Integrations', 'AI Content Generation']
            }
          },
          [SubscriptionPlan.BUSINESS_PLAN_NAME]: {
            text: startCase(SubscriptionPlan.BUSINESS_PLAN_NAME),
            price: '<span>49.99$/m</span> &nbsp; <span style="text-decoration: line-through; font-size: 12px; color: grey">99.99$/m</span>',
            features: {
              title: 'Features',
              content: ['10 Stores, 10 Domains', 'Unlimited Products', 'Unlimited Sale Pages', 'Unlimited Orders', '0% Transactions Fees', 'Advanced Statistics', 'Advanced Apps', 'Chat and Phone Support', 'Team Members (20)', 'External API Integrations', 'Pro AI Content Generation']
            }
          }
        }
      },
      user_youtube_channel: {
        title: 'Youtube Channel',
        placeholder: 'Youtube channel link'
      },
      user_name: {
        title: 'Username',
        placeholder: 'Username'
      },
      store_name: {
        title: 'Store name',
        placeholder: 'mystore',
        hint: 'only english letter, numbers and - are allowed.'
      },
      store_language: {
        title: 'Store language',
        options: {
          en: 'English',
          ar: 'Arabic',
          fr: 'French',
          it: 'Italian',
          es: 'Spanish'
        }
      },
      user_full_name: {
        title: 'Full name',
        placeholder: 'Full name'
      },
      user_country: {
        title: 'Country',
        placeholder: 'Select country'
      },
      user_email: {
        title: 'Email',
        placeholder: 'Email address'
      },
      user_password: {
        title: 'Password',
        placeholder: 'Password'
      },
      user_password_confirmation: {
        title: 'Password confirmation',
        placeholder: 'Repeat password'
      },
      user_presentation: {
        title: 'Where did you hear about us?',
        placeholder: 'Tell us about where did hear about Maxcom Stores.',
        options: {
          default_option: 'Select where you heard about us'
        }
      }
    },
    password_reset: {
      reset_new_password: 'reset new password',
      back_to_login: 'Back to Login',
      request_password: {
        title: 'New password',
        placeholder: 'New password'
      },
      request_password_repeat: {
        title: 'New password confirmation',
        placeholder: 'New password confirmation'
      }
    }
  },
  components: {
    from_to_component: {
      from: 'From',
      to: 'To',
      days: 'Days'
    },
    side_bar_item: {
      tooltip: {
        upgrade_plan: 'Upgrade to unlock this powerful feature and grow your store faster!'
      }
    },
    ai_content_generator: {
      title: 'Generate Content',
      form: {
        fields: {
          model_name: {
            title: 'ChatGpt model name',
            placeholder: 'Select the model name'
          },
          product_title: {
            title: 'Product title',
            we_will_use: 'We will use this info to generate the sale page text, you can correct it or optimize it before we start.',
            placeholder: 'Write your preferred version of the product name'
          },
          product_description: {
            title: 'Product Description',
            placeholder: 'Describe the product here'
          },
          country: {
            title: 'Country',
            placeholder: 'Type a country name'
          },
          language: {
            title: 'Language'
          },
          gender_options: {
            men: 'Men',
            women: 'Women',
            men_and_women: 'Men & Women'
          },
          buttons: {
            generate_content: 'Generate Content'
          }
        }
      },
      update_content_fields: {
        title: 'Edit Block Text',
        fields: {
          content: {
            title: 'Headline',
            placeholder: 'Add text here...'
          }
        },
        buttons: {
          save: 'Save',
          cancel: 'Cancel'
        }
      },
      update_content_generated: {
        title: 'Display Generated Content',
        wait: 'This might take some time please wait...',
        sorry: 'Sorry! we encountered a problem, please try again.',
        edit_field: {
          title: 'Update Content',
          fields: {
            content: {
              title: 'Headline',
              placeholder: 'Add text here...'
            }
          },
          buttons: {
            update: 'Update content',
            cancel: 'Cancel'
          }
        },
        buttons: {
          add: 'Add To page',
          update: 'Update with ai',
          cancel: 'Cancel'
        }
      }
    },
    edit_columns: {
      title: 'Edit Columns',
      reset: 'Reset'
    },
    subscription_dialog: {
      you_are_in: 'you\'re in',
      upgrade: 'Upgrade',
      title: 'Subscription Plan',
      button: {
        current_plan: 'Your Current Plan',
        upgrade_plan: 'Upgrade to {plan}',
        downgrade_plan: 'Downgrade to {plan}',
        next_plan: 'Next Plan',
        error: 'Error'
      },
      price: '{price}/Month',
      plans: {
        [SubscriptionPlan.BASIC_PLAN_NAME]: {
          title: startCase(SubscriptionPlan.BASIC_PLAN_NAME),
          features: ['1 Store, 1 Domain', '1 External API', '10 AI Products Pages', 'Unlimited Products', 'Unlimited Sale Pages', 'Unlimited Orders', 'Transactions Fees 0%', 'Basic Statistics', 'Basic Apps', 'Ticket Support', 'No Team Members']
        },
        [SubscriptionPlan.ADVANCED_PLAN_NAME]: {
          title: startCase(SubscriptionPlan.ADVANCED_PLAN_NAME),
          features: ['2 Stores, 2 Domains', 'Unlimited API Integrations', 'Unlimited AI Products Pages', 'Unlimited Products', 'Unlimited Sale Pages', 'Unlimited Orders', 'Transactions Fees 0%', 'Advanced Statistics', 'Advanced Apps', 'Chat Support', 'Team Members (2)']
        },
        [SubscriptionPlan.BUSINESS_PLAN_NAME]: {
          title: startCase(SubscriptionPlan.BUSINESS_PLAN_NAME),
          features: ['10 Stores, 10 Domains', 'Unlimited API Integrations', 'Unlimited Pro AI Products Pages', 'Unlimited Products', 'Unlimited Sale Pages', 'Unlimited Orders', 'Transactions Fees 0%', 'Advanced Statistics', 'Advanced Apps', 'Chat and Phone Support', 'Team Members (20)']
        }
      }
    },
    image_library: {
      title: 'Library'
    },
    import_orders: {
      title: 'Import Orders',
      text: 'Please enter your orders data, by clicking on a table cell you can enter a value.',
      table: {
        columns: {
          order_date: 'Order Date',
          custom_id: 'Custom ID',
          full_name: 'Full Name*',
          phone: 'Phone*',
          country: 'Country*',
          address: 'Address',
          sale_page: 'Sale Page*',
          quantity: 'Quantity*'
        }
      },
      notes: {
        title: 'Notes',
        bullets: {
          one: 'In the sale page column an id must be pasted, or choose a sale page from the list.',
          two: 'In the country column the name of the country must be pasted.',
          three: 'The Custom ID is optional, you can add it to identify your orders by your custom IDs'
        }
      },
      validationDialog: {
        title: 'Validation Errors',
        text: 'please check the cell comment for hints about the data validation.',
        dont_show_again: 'I understand, don\'t show me this again.',
        actions: {
          close: 'close'
        }
      },
      actions: {
        upload: 'Upload'
      }
    },
    live_chat_widget_addon: {
      form: {
        alert: {
          accountIdInfo: 'You can get your <span style="font-weight: bold">Property ID</span> from <span style="font-weight: bold">Administration > Overview</span>',
          widgetIdInfo: 'You can get your <span style="font-weight: bold">Widget ID</span> from <span style="font-weight: bold">Administration > Channels > Chat Widget</span>'
        },
        fields: {
          is_enabled: {
            title: 'Live Chat With Tawk.to'
          },
          account_id: {
            title: 'Property ID',
            placeholder: '12fg896gfrtvr15rgr21r'
          },
          widget_id: {
            title: 'Widget ID',
            placeholder: '58fg54515rf'
          }
        }
      }
    },
    option_form: {
      option_name: {
        title: '',
        translation: {
          option_1: '1 Piece',
          option_2: '2 Pieces',
          option_3: '3 Pieces',
          option_4: '4 Pieces',
          option_5: '5 Pieces'
        }
      },
      discount: {
        title: 'Discount text (optional)',
        placeholder: 'discount'
      },
      normal_price: {
        title: 'Old Price (optional)'
      },
      sale_price: {
        title: 'Sale Price'
      }
    },
    offer_option_form: {
      offer_name: {
        title: 'Offer Name',
        content: {
          x_product: '{x}x Product name',
          buy_get_free: 'Buy {buy} Get {free} Free'
        },
        placeholder: 'offer name'
      },
      discount: {
        content: '{{dis}} off - {{up}}/piece'
      }
    },
    upsell_option_form: {
      option_name: {
        upsell_1: 'Upsell 1',
        upsell_2: 'Upsell 2',
        upsell_3: 'Upsell 3'
      },
      offer_name: {
        placeholder: 'offer name',
        content: {
          upsell_1: 'offer name -50% OFF',
          upsell_2: 'offer name',
          upsell_3: 'Add 1 Year guarantee for only ?'
        }
      },
      offer_nick_name: {
        placeholder: 'Offer Nickname'
      },
      discount: {
        content: {
          normal: '{{dis}}',
          warranty: '1 Year Guarantee for 1 item'
        }
      }
    },
    cross_sell_option_form: {
      option_name: {
        cross_sell_1: 'Cross Sell 1',
        cross_sell_2: 'Cross Sell 2'
      },
      offer_id: {
        placeholder: 'Select an offer'
      },
      product_id: {
        placeholder: 'Select an product'
      },
      offer_nick_name: {
        placeholder: 'Offer Nickname'
      },
      product_nick_name: {
        placeholder: 'Product Nickname'
      },
      discount: {
        content: {
          normal: '{{dis}}',
          warranty: '1 Year Guarantee for 1 item'
        }
      }
    },
    sale_page_allowed_countries_component: {
      is_enabled: {
        title: 'Make Sale Page Visible By Country'
      },
      country_select_type: {
        title: 'Actions type',
        options: {
          [AllowedCountriesAddon.WHITE_LIST_TYPE]: startCase(AllowedCountriesAddon.WHITE_LIST_TYPE),
          [AllowedCountriesAddon.BLACK_LIST_TYPE]: startCase(AllowedCountriesAddon.BLACK_LIST_TYPE)
        }
      },
      country_select: {
        title: 'List of counties',
        hint: 'Please select one or many countries',
        placeholder: 'choose the countries allowed to see this page',
        info: 'You can select the countries you are targeting, and we will redirect all untargeted countries visitors to the home page.'
      }
    },
    identity_verification_setting: {
      title: 'Identity Verification',
      subtitle: 'Identity verification',
      verification_rejection_message: 'Sorry ! your verification has been rejected.',
      verification_success_message: 'Your account is verified.',
      verification_pending_message: 'Your verification is pending. please wait for you verification to be submitted',
      form: {
        fields: {
          full_name: {
            title: 'Full Name',
            placeholder: 'Type you full name'
          },
          id_front_image: {
            title: 'Identification Card Front image'
          },
          id_back_image: {
            title: 'Identification Card Back image'
          },
          accept_terms_and_conditions: {
            title: {
              part_one: 'I agree to ',
              part_two: 'terms and conditions.'
            }
          }
        },
        buttons: {
          title: 'Save changes'
        }
      }
    },
    pixel_component: {
      no_pixel_added: 'No pixel has been added',
      pixel_title: 'Title',
      conversion_event_name: 'Conversion event',
      form: {
        fields: {
          facebook: {
            title: 'Pixel ID',
            placeholder: 'Pixel ID',
            conversion_names: {
              [Pixel.CONVERSION_PURCHASE]: startCase(Pixel.CONVERSION_PURCHASE),
              [Pixel.CONVERSION_LEAD]: startCase(Pixel.CONVERSION_LEAD)
            }
          },
          snapchat: {
            title: 'Pixel ID',
            placeholder: 'Pixel ID'
          },
          twitter: {
            title: 'Pixel ID',
            placeholder: 'Pixel ID'
          },
          google: {
            title: 'Tag ID',
            placeholder: 'GTM-XXXXXX'
          },
          tiktok: {
            title: 'Pixel ID',
            placeholder: 'Pixel ID',
            conversion_names: {
              [Pixel.CONVERSION_COMPLETE_PAYMENT]: startCase(Pixel.CONVERSION_COMPLETE_PAYMENT),
              [Pixel.CONVERSION_PLACE_AN_ORDER]: startCase(Pixel.CONVERSION_PLACE_AN_ORDER)
            }
          },
          microsoft_clarity: {
            title: 'Project ID',
            placeholder: 'Project ID'
          },
          google_tag: {
            title: 'Tag ID',
            placeholder: 'G-XXXXXX OR AW-XXXXXX'
          },
          postback: {
            title: 'Postback url',
            placeholder: 'https://your_postback_url?cid={cid}&payout={payout}'
          },
          token: {
            title: 'API Token (optional)'
          }
        }
      }
    },
    woo_commerce: {
      title: 'Connect your WooCommerce',
      subtitle: 'Get all your orders uploaded automatically to your Woocommerce store! just connect it and ' + 'we will keep it updated with your promoted offers and orders on time',
      dialog: {
        delete: {
          title: 'Delete Store domain',
          content: 'Are you sure you want to delete this store domain ?'
        }
      },
      mapping_products: {
        title: 'Offers and Products mapping',
        subtitle: 'Connect an offer to the corresponding product in your woocommerce store, to receive orders for the selected product in woocommerce.',
        ps: 'If you receive a new order for an offer that is not connected to your woocommerce product, we will have to create a new product in your woocommerce store and we will use it to send orders to your store.' + '</br>You can also change the connected product for the offer anytime you want (the same thing applies for the variations).',
        table: {
          offer_id: 'Offer ID',
          offer_image: 'Image',
          offer_name: 'Offer Name',
          offer_country: 'Country',
          wc_product: 'Woocommerce product',
          actions: 'Actions'
        },
        buttons: {
          save_mapping: {
            tooltip: 'Save product mapping.'
          },
          variation_mapping: {
            tooltip: 'Variation mapping, </br>connect product variations with woocommerce variations'
          }
        },
        mapping_variations: {
          title: 'Product Variations mapping',
          subtitle: 'Connect product variations to the corresponding product variation in your woocommerce store.'
        }
      },
      mapping_product_variations: {
        title: 'Product Variation mapping',
        subtitle: 'Connect product variation to the corresponding product variation in your woocommerce store.',
        table: {
          variation_id: 'Variation ID',
          image: 'Image',
          sku: 'Sku',
          options: 'Options',
          wc_product_variation: 'Woocommerce product variation',
          actions: 'Actions'
        }
      },
      form: {
        fields: {
          domain_name: {
            title: 'Your WooCommerce domain name:',
            placeholder: 'www.example.com'
          },
          sync_info: {
            title: 'Get back order shipping info from Woocommerce ?'
          }
        },
        buttons: {
          connect: 'Connect',
          add: 'Add domain'
        }
      },
      table: {
        domain_name: 'Connected store',
        user_name: 'Username',
        status: 'Status',
        last_update: 'Last update',
        actions: 'Actions',
        enable_or_disable: 'Send orders to your store',
        get_status_by_domain: 'Get data from your store',
        tooltips: {
          connect: 'connect to woocommerce store',
          mapping: 'Products mapping: connect woocommerce products with offers',
          enable_or_disable: 'enable/disable sending orders to your store',
          delete_domain: 'delete store from the list',
          get_status_by_domain: 'get order status from your store'
        }
      }
    },
    application_shopping: {
      title: 'Create products Feeds for your promoted offers',
      subtitle: {
        [product_feed_types.FACEBOOK_FEED]: 'Here you can setup and generate Facebook “Commerce manager” products feeds for your domains and promoted products.',
        [product_feed_types.GOOGLE_FEED]: 'Here you can setup and generate google shopping feeds for your domains and promoted products.'
      },
      info: 'you should have already generated a sale page for an offer by your domain name to see its product included in your generated feed.',
      dialogs: {
        feed_products: {
          title: 'List of products on your feed',
          beforeSubTitle: 'Here you can Edit some products info like image, title, description, Sale page, and you can exclude products from the feed.',
          subtitle: '<span style="color: red">P.S:</span> The product title and description should be in the same language of your Sale page, if not, please translate them before submitting the feed.',
          table: {
            product_id: 'Product ID',
            product_image: 'Main image',
            product_title: 'Title',
            product_description: 'Description',
            product_brand: 'Brand',
            product_sale_page: 'Sale page',
            product_sale_price: 'Sale price',
            product_status: 'Status'
          },
          buttons: {
            save: 'Save changes'
          }
        },
        delete: {
          title: 'Delete Feed',
          content: 'Are you sure you want to delete this feed ?'
        }
      },
      form: {
        site_verification_text: 'Get your {application_name} verification string from your {application_name} ' + 'account and paste it here to verify your domain name ownership in {application_name}. (copy only the verification string code)',
        your_verification_string_here: 'YOUR VERIFICATION STRING HERE',
        fields: {
          domain: {
            title: 'Domain',
            placeholder: ''
          },
          verification_string: {
            title: 'domain verification string',
            before_text: 'Save domain verification string',
            placeholder: ''
          },
          country: {
            title: 'Country',
            before_text: 'Fill this info to create a new feed',
            placeholder: ''
          },
          feed_name: {
            title: 'Feed Name',
            placeholder: ''
          }
        }
      },
      buttons: {
        generate_feed: 'Generate feed'
      },
      table: {
        feed_id: 'Feed ID',
        user: 'Username',
        domain: 'domain name',
        feed_name: 'Feed Name',
        target_country: 'Target Country',
        submitted_products: 'Submitted Products',
        actions: 'Actions'
      }
    },
    library: {
      images: 'Images',
      videos: 'Videos',
      image_tab: {
        no_images_found: 'No images found.'
      },
      video_tab: {
        no_videos_found: 'No videos found.'
      }
    },
    chart: {
      chart_evolution_text: 'Evolution of Earnings and conversions by selected period',
      date: 'Date',
      chart_colors: {
        earnings: 'Earnings'
      }
    },
    payment_processors: {
      title: 'Payment processors',
      subtitle: 'Payment processors',
      one_account_requirement_alert: 'At least one Stripe account must stay active, otherwise an error will be thrown on all payment forms.',
      seller_subscription_accounts: 'These stripe accounts are for seller subscription use only.',
      wait_for_webhook_sync: 'After changing the stripe keys please wait one to two minutes for the changes to take affect.',
      stripe_form: {
        fields: {
          name: {
            title: 'Name',
            placeholder: 'Main stripe account'
          },
          live_secret_key: {
            title: 'Live secret Key',
            placeholder: 'ps_live_ ...'
          },
          live_public_key: {
            title: 'Live public Key',
            placeholder: 'pk_live_ ...'
          },
          test_secret_key: {
            title: 'Test secret Key',
            placeholder: 'ps_test_ ...'
          },
          test_public_key: {
            title: 'Test public Key',
            placeholder: 'pk_test_ ...'
          },
          wallet: {
            title: 'Activate Wallet (google and apple pay)'
          }
        },
        dialogs: {
          delete: {
            title: 'Delete stripe account',
            content: 'Are you sure you want to delete this stripe account?'
          }
        },
        buttons: {
          add_stripe: 'Add new stripe account',
          save: 'Save keys'
        }
      }
    },
    payment_information: {
      title: 'Payment information',
      subtitle: 'You can get paid for qualified orders by Payoneer (no fees) or by Bank transfer ($5 to $15 fees).<br><br>' + 'The minimum payout amount is $50',
      please_select: 'Please select your preferred payment method',
      form: {
        fields: {
          bank_choice: {
            options: {
              bank_details: 'Bank Transfer'
            }
          }
        }
      },
      bank_details: {
        title: 'Bank Details',
        subtitle: 'Fill your Bank details here',
        form: {
          fields: {
            beneficiary_name: {
              title: 'Beneficiary name',
              placeholder: 'Type your Beneficiary name'
            },
            country: {
              title: 'Bank country',
              placeholder: 'Select your bank country'
            },
            name: {
              title: 'Bank name',
              placeholder: 'Type your bank name'
            },
            account_number: {
              title: 'Account number',
              placeholder: 'Type your account number'
            },
            swift_code: {
              title: 'Swift code',
              placeholder: 'Type your swift code'
            },
            bank_address: {
              title: 'Bank address',
              placeholder: 'Type your bank address'
            }
          }
        }
      },
      payoneer: {
        title: 'Payoneer',
        subtitle: 'Fill your Payoneer details here',
        form: {
          fields: {
            beneficiary_name: {
              title: 'Beneficiary name',
              placeholder: 'Type your Beneficiary name'
            },
            payoneer: {
              title: 'Payoneer email',
              placeholder: 'Type your Payoneer'
            }
          }
        }
      },
      buttons: {
        save: 'Save Information'
      }
    },
    account_tracking: {
      tracking_by_pixels: {
        title: 'Tracking by Pixels',
        subtitle: 'Add your global tracking information here.' + ' You only need to add pixel ID, not pixel code. All the pixels ID you save here will be used in your offers sales' + ' pages, unless you change it in the Offer pixel section.',
        form: {
          fields: {
            facebook: {
              title: 'facebook pixel ID',
              placeholder: 'Pixel ID'
            },
            snapchat: {
              title: 'snapchat pixel ID',
              placeholder: 'Pixel ID'
            },
            twitter: {
              title: 'twitter pixel ID',
              placeholder: 'Pixel ID'
            },
            google: {
              title: 'google tag ID',
              placeholder: 'GTM-XXXXXX'
            },
            tiktok: {
              title: 'tiktok pixel ID',
              placeholder: 'Pixel ID'
            },
            microsoft_clarity: {
              title: 'microsoft clarity project ID',
              placeholder: 'Project ID'
            },
            google_tag: {
              title: 'google tag ID',
              placeholder: 'G-XXXXXX or AW-XXXXXX'
            }
          }
        }
      },
      tracking_by_postback_url: {
        title: 'Tracking by Postback URL',
        subtitle: 'We can feedback click id and payout to your' + ' postback url, make sure to' + ' include these tokens in your postback url: {cid} for click ID, and {payout} for offer payout.',
        subtitle2: 'Example:',
        form: {
          fields: {
            postback_url: {
              title: 'Postback url',
              placeholder: 'https://example.com'
            }
          }
        }
      },
      buttons: {
        save: 'Save information'
      }
    },
    account_settings: {
      title: 'Account Settings',
      subtitle: 'Change your personal information here.',
      form: {
        fields: {
          full_name: {
            title: 'Full name',
            placeholder: 'Type your full name'
          },
          company: {
            title: 'Company name',
            placeholder: 'Type your company name'
          },
          country: {
            title: 'Country name',
            placeholder: 'Select your country name'
          },
          username: {
            title: 'Username',
            placeholder: 'Type your username'
          },
          email: {
            title: 'Email',
            placeholder: 'Type your email'
          },
          phone: {
            title: 'Phone',
            placeholder: 'Type your phone number'
          },
          old_password: {
            title: 'Old password',
            placeholder: 'Type your old password'
          },
          skype: {
            title: 'Skype',
            placeholder: 'Type your skype id'
          },
          new_password: {
            title: 'New password',
            placeholder: 'Type your new password'
          },
          confirmed_password: {
            title: 'Confirmation password',
            placeholder: 'Type your new confirmation password'
          },
          news_letter: {
            title: 'Subscribe to our news letter'
          },
          send_order_email: {
            title: 'Send me an email on new upcoming orders.'
          }
        },
        buttons: {
          save: 'Save account'
        }
      }
    },
    tracking: {
      pixel_type: {
        [Pixel.FACEBOOK]: startCase(Pixel.FACEBOOK),
        [Pixel.GOOGLE]: 'Google Tag Manager',
        [Pixel.SNAPCHAT]: startCase(Pixel.SNAPCHAT),
        [Pixel.TIKTOK]: startCase(Pixel.TIKTOK),
        [Pixel.TWITTER]: startCase(Pixel.TWITTER),
        [Pixel.POSTBACK]: startCase(Pixel.POSTBACK),
        [Pixel.MICROSOFT_CLARITY]: startCase(Pixel.MICROSOFT_CLARITY),
        [Pixel.GOOGLE_TAG]: 'Google Analytics'
      }
    },
    domain_names: {
      create_domain: 'Add domain',
      create_new_domain: 'Add new domain',
      update_domain: 'Update domain',
      title: 'Domain Names',
      subtitle: 'Follow the steps bellow to configure you domain',
      type: 'Type:',
      name_host: 'Name/Host:',
      ip_address: 'IP Address:',
      filter: {
        search: {
          title: 'Search',
          placeholder: 'search by domain name'
        }
      },
      domain_types_desc: {
        [Store.GENERAL_TYPE]: [startCase(Store.GENERAL_TYPE), 'Store', '(for many offers)'].join(' '),
        [Store.COUNTRY_TYPE]: [startCase(Store.COUNTRY_TYPE), 'Store', '(for one country)'].join(' '),
        [Store.BRAND_TYPE]: [startCase(Store.BRAND_TYPE), 'Store', '(for one offer)'].join(' ')
      },
      table: {
        user_name: 'User name',
        domain: 'Domain',
        payment_wallet: 'Payment Wallet',
        ssl: 'SSL',
        dns: 'DNS',
        logo: 'Logo ( 400x80px )',
        email: 'Email',
        store: 'Store title',
        favicon: 'Favicon ( 32x32px )',
        actions: 'Actions'
      },
      form: {
        step_one: {
          title: 'Step 2:',
          subtitle: 'Add new domain'
        },
        step_two: {
          title: 'Step 1: (in Your domain registrar dashboard)',
          subtitle: 'Go to your domain DNS settings, and Add or Change Your domain “A” record to point to our server IP address:',
          add_cname: '<span><strong>Optional:</strong> You can add a CNAME record like this to make your domain accessible by WWW. (replace yourdomain.com with your domain name)</span>'
        },
        step_three: {
          title: 'Step 3:',
          subtitle: 'Wait for the status of DNS and SSL to be ready before you start using your domain.'
        },
        fields: {
          type: {
            step: 'How you will use this domain?'
          },
          warning: {
            title: 'Please wait 1 to 3 minutes for the domains to be added with SSL.'
          },
          store_choice: {
            options: {
              new_store: 'Create new store',
              existing_store: 'Choose an existing store'
            }
          },
          language: {
            title: 'Store Default Language',
            options: {
              english: 'English',
              arabic: 'Arabic',
              spanish: 'Spanish',
              french: 'French',
              italian: 'Italian'
            }
          },
          product: {
            title: 'Select the brand product'
          },
          layout: {
            title: 'Store layout for Header & Footer'
          },
          country: {
            title: 'Select the store country'
          },
          name: {
            title: 'domain name',
            hint: 'the domain name must container only english letters, numbers and -, but no www.'
          },
          title: {
            title: 'Store title',
            placeholder: 'Type the store title'
          },
          email: {
            step: 'Contact info (optional - will be displayed on footer and contact page)',
            title: 'Customer support email',
            hint: 'default: contact@maxcomshop.com'
          },
          logo: {
            step: 'Store logo and colors',
            title: 'Website Logo ( size: 400x80 px )'
          },
          tracking_data: {
            step: 'Tracking Data',
            title: 'Pixels'
          },
          favicon: {
            title: 'Website Favicon ( size: 32x32 px, optional )'
          },
          primary_color: {
            title: 'Store primary color (Dark)'
          },
          secondary_color: {
            title: 'Store secondary color (Light)'
          },
          company_location: {
            title: 'Company Address',
            placeholder: 'Company address...'
          },
          phone_number: {
            title: 'Phone Number',
            placeholder: '123 456 789'
          }
        },
        buttons: {
          add: 'Add domain',
          save: 'Save domain',
          cancel: 'Cancel'
        }
      }
    },
    date_piker: {
      today: 'Today',
      yesterday: 'Yesterday',
      this_week: 'This Week',
      last_week: 'Last Week',
      this_month: 'This Month',
      last_month: 'Last Month',
      this_year: 'This Year'
    },
    multiple_upload: {
      open_library: 'Open library',
      upload: 'Upload',
      upload_images: 'Upload images',
      please_select_images: 'Please select your images.',
      upload_videos: 'Upload videos',
      please_select_videos: 'Please select your videos.',
      library: 'Library',
      upload_files: 'Upload files'
    },
    confirmation_dialog: {
      yes: 'Yes',
      save: 'Save',
      no: 'No'
    },
    draggable_zone: {
      you_block_appear_here: 'your sale page blocks will appear here.',
      add_review: 'Add review'
    },
    dialog_upload: {
      please_wait: 'please wait...',
      upload_to_cloud: 'upload to cloud',
      or_choose_from: 'Or choose from',
      library: 'Library',
      upload_files: 'Upload files'
    },
    header_block: {
      text: 'Header',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          }
        }
      }
    },
    hero_block: {
      text: 'Hero Section',
      form: {
        fields: {
          fill: {
            options: {
              home: 'Home hero block'
            }
          },
          text: {
            title: 'Description',
            placeholder: 'Type a description...'
          },
          button_text: {
            title: 'Button text',
            placeholder: 'Discover'
          },
          image: {
            title: 'Image'
          }
        }
      }
    },
    block: {
      form: {
        fields: {
          fill: {
            fields: {
              ready_field: {
                placeholder: 'Select Ready content'
              }
            },
            buttons: {
              fill: {
                title: 'Fill'
              }
            }
          },
          block_visibility: 'Show block borders',
          background_color: 'Background color',
          background: {
            is_enabled: 'Choose a custom background color',
            color: 'Background color'
          },
          headline: {
            is_enabled: 'Choose a custom headline color',
            color: 'Headline color'
          },
          head_line_color: 'HeadLine color',
          background_full_screen: 'Background takes full width.',
          content_full_screen: 'Image takes full width in mobile.',
          is_after_checkout: 'Display block after checkout form.',
          is_background_gradient: 'Background Gradient.',
          sticky: 'Sticky.'
        }
      }
    },
    bullet_block: {
      text: 'Bullet points',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          block_image_border_visibility: {
            title: 'Show image borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          bullet_one: {
            title: 'Bullet point 1',
            placeholder: 'Function 1 ...'
          },
          bullet_two: {
            title: 'Bullet point 2',
            placeholder: 'Function 2 ...'
          },
          bullet_three: {
            title: 'Bullet point 3',
            placeholder: 'Benefit 1 ...'
          },
          bullet_four: {
            title: 'Bullet point 4',
            placeholder: 'Benefit 2 ...'
          },
          bullet_five: {
            title: 'Bullet point 5',
            placeholder: 'Material, Fabrics,...'
          },
          image_max_width: {
            title: 'image max width',
            placeholder: 'type the max with of your image',
            hint: 'ps: it\'s recommended that you set a value between 500 and 700'
          }
        }
      }
    },
    button_block: {
      text: 'Buy button',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          text: {
            title: 'Button Text',
            placeholder: 'Buy now, order now ...'
          },
          show_price: {
            title: 'Show the price'
          },
          under_button_text: {
            title: 'Under Button text',
            placeholder: 'Pay by Cash on Delivery'
          }
        }
      }
    },
    gallery_block: {
      text: 'Gallery',
      trust_badges: {
        free_shipping: 'Free Shipping',
        return_guarantee: 'Return Guarantee',
        secure_payment: 'Secure Checkout',
        fast_support: 'Quick Support'
      },
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          image: {
            title: 'Slider images'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          product_name: {
            title: 'Short Product Name',
            placeholder: 'type your Short Product Name'
          },
          bullet_one: {
            title: 'Bullet point 1',
            placeholder: 'Function 1 ...'
          },
          bullet_two: {
            title: 'Bullet point 2',
            placeholder: 'Function 2 ...'
          },
          bullet_three: {
            title: 'Bullet point 3',
            placeholder: 'Benefit 1 ...'
          },
          bullet_four: {
            title: 'Bullet point 4',
            placeholder: 'Benefit 2 ...'
          },
          bullet_five: {
            title: 'Bullet point 5',
            placeholder: 'Material, Fabrics,...'
          },
          button: {
            title: 'Button Text',
            placeholder: 'Buy now, order now ...'
          },
          under_button: {
            title: 'Under Button text',
            placeholder: 'Pay by Cash on Delivery'
          }
        }
      }
    },
    brand_domain_block: {
      text: 'Brand domain Content',
      page_will_be_displayed_automatically: 'Page will be displayed automatically.',
      select_page: 'Please, Select your custom page.',
      form: {
        fields: {
          fill: {
            options: {
              discover_products: 'Discover our products'
            }
          },
          page_select_type: {
            title: 'Page display type'
          },
          page: {
            title: 'Sale page',
            placeholder: 'Choose \'auto\' or one sale page.'
          }
        }
      }
    },
    product_list_block: {
      text: 'Product List',
      products_will_be_displayed_automatically: 'Products will be displayed automatically.',
      select_products: 'Please, Select your custom products.',
      form: {
        fields: {
          fill: {
            options: {
              discover_products: 'Discover our products'
            }
          },
          title: {
            title: 'Title',
            placeholder: 'Our products...'
          },
          list_select_type: {
            title: 'List display type'
          },
          product_list: {
            title: 'Product List',
            placeholder: 'Choose \'auto\' or one or multiple products.'
          },
          list: {
            title: 'Offer List',
            placeholder: 'Choose \'auto\' or one or multiple offers.'
          }
        }
      }
    },
    article_block: {
      text: 'Article Text',
      form: {
        fields: {
          fill: {
            options: {
              about: 'About page block',
              refund_policy: 'Refund policy page block',
              privacy_policy: 'Privacy policy page block',
              service_terms: 'Service terms page block',
              shipping_and_return: 'Shipping and return page block'
            }
          },
          title: {
            title: 'Title',
            placeholder: ' write a title'
          },
          content: {
            title: 'Content',
            placeholder: 'type the content'
          }
        }
      }
    },
    contact_block: {
      text: 'Contact Text',
      form: {
        fields: {
          fill: {
            options: {
              contact: 'Contact page contact block'
            }
          },
          title: {
            title: 'Title',
            placeholder: ' write a title'
          },
          content: {
            title: 'Content',
            placeholder: 'type the content'
          }
        }
      }
    },
    navigation_link_block: {
      text: 'Link',
      form: {
        fields: {
          link: {
            title: 'Link'
          },
          name: {
            title: 'Name'
          }
        }
      }
    },
    footer_links_block: {
      text: 'Footer Links',
      form: {
        fields: {
          title: {
            title: 'Title'
          }
        }
      }
    },
    footer_info_block: {
      text: 'Footer Info',
      form: {
        fields: {
          domain_logo_visibility: 'Logo Visible',
          domain_name_visibility: 'Domain Name Visible',
          domain_email_visibility: 'Domain Email Visible',
          domain_phone_visibility: 'Domain Phone Visible',
          domain_company_visibility: 'Domain Company Visible',
          social_medial_links: {
            title: 'Social Media Links',
            empty_text: 'your social media link blocks appear here.',
            buttons: {
              add: 'Add Link'
            }
          }
        }
      }
    },
    page_footer_block: {
      text: 'Page Footer',
      empty_text: 'your sections will appear here',
      buttons: {
        add: 'add Section'
      },
      form: {
        fields: {
          fill: {
            options: {
              default: 'Default Footer'
            }
          },
          list: {
            title: 'Section List'
          }
        }
      }
    },
    content_placeholder_block: {
      text: 'Content Placeholder',
      store_page: 'Store Page Content'
    },
    link_block: {
      text: 'Link',
      form: {
        fields: {
          link: {
            title: 'Link',
            placeholder: '/home'
          },
          name: {
            title: 'Name',
            placeholder: 'Home'
          }
        }
      }
    },
    footer_benefits_block: {
      text: 'Footer Benefits',
      form: {
        fields: {
          paragraph: {
            title: 'Text'
          },
          features_image: {
            title: ''
          }
        }
      }
    },
    page_header_block: {
      text: 'Page Header',
      empty_text: 'your links will appear here',
      form: {
        fields: {
          fill: {
            options: {
              default: 'Default Header'
            }
          },
          links: {
            title: 'Links'
          }
        }
      },
      buttons: {
        add: 'Add Link'
      }
    },
    social_media_link_block: {
      text: 'Social Media Link',
      form: {
        fields: {
          type: {
            title: 'Type'
          },
          link: {
            title: 'Link',
            placeholder: 'https://facebook.com/xxxx'
          }
        }
      }
    },
    compliance_bar_block: {
      text: 'CopyRight Bar',
      form: {
        fields: {
          fill: {
            options: {
              default_compliance: 'Copy Right'
            }
          },
          text: {
            title: 'Text',
            placeholder: 'Write a text'
          }
        }
      }
    },
    announcement_bar_block: {
      text: 'Announcement Bar',
      form: {
        fields: {
          fill: {
            options: {
              default_announcement: 'Free Shipping'
            }
          },
          text: {
            title: 'Text',
            placeholder: 'Write a text'
          }
        }
      }
    },
    journal_block: {
      text: 'Paragraph Text',
      form: {
        fields: {
          fill: {
            options: {
              amazing_delivery_experience: 'Amazing Delivery Experience',
              best_customer_service: 'The Best Customer Service',
              about_us: 'About Us'
            }
          },
          block_visibility: {
            title: 'Show block borders'
          },
          block_image_border_visibility: {
            title: 'Show image borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          paragraph: {
            title: 'Paragraph',
            placeholder: 'write your paragraph'
          },
          image_max_width: {
            title: 'image max width',
            placeholder: 'type the max with of your image',
            hint: 'ps: it\'s recommended that you set a value between 400 and 700'
          }
        }
      }
    },
    faq_block: {
      text: 'FAQ',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Question',
            placeholder: 'Type your question'
          },
          text: {
            title: 'Answer',
            placeholder: 'Type your answer'
          }
        }
      }
    },
    faqs_block: {
      text: 'FAQS',
      form: {
        fields: {
          fill: {
            options: {
              home: 'Home faqs',
              faqs: 'Faq page faqs'
            }
          },
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'HeadLine',
            placeholder: 'Type the headline'
          },
          faq_list: {
            title: 'Faq List'
          },
          other_questions_title: {
            title: 'Other questions title',
            placeholder: 'Do you have any other questions?'
          },
          other_questions_text: {
            title: 'Other questions text',
            placeholder: 'Please contact us...'
          },
          other_questions_button_text: {
            title: 'Other questions button text',
            placeholder: 'Contact us'
          }
        }
      },
      buttons: {
        add: 'Add question'
      }
    },
    figure_block: {
      text: 'Text column',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          image: {
            title: 'Column image'
          },
          paragraph: {
            placeholder: 'Column description'
          }
        }
      }
    },
    figures_block: {
      text: 'Text columns',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          figures_list: {
            title: 'Text Columns List'
          }
        }
      },
      buttons: {
        add: 'Add column'
      }
    },
    reviews_block: {
      text: 'Customer reviews',
      buttons: {
        add: 'Add review'
      },
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          reviews_list: {
            title: 'Reviews List'
          }
        }
      }
    },
    review_block: {
      text: 'Customer review',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          profile_image: {
            title: 'Profile image'
          },
          star_rating: {
            title: 'Star rating'
          },
          user_name: {
            title: 'Username',
            placeholder: 'type your username'
          },
          text: {
            title: 'Review comment',
            placeholder: 'write your Review comment'
          },
          product_image: {
            title: 'Product image'
          }
        }
      }
    },
    simple_gallery_block: {
      text: 'Simple Gallery',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          block_image_border_visibility: {
            title: 'Show block image borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          product_name: {
            title: 'Short Product Name',
            placeholder: 'type your Short Product Name'
          },
          bullet_one: {
            title: 'Bullet point 1',
            placeholder: 'Function 1 ...'
          },
          bullet_two: {
            title: 'Bullet point 2',
            placeholder: 'Function 2 ...'
          },
          bullet_three: {
            title: 'Bullet point 3',
            placeholder: 'Benefit 1 ...'
          },
          bullet_four: {
            title: 'Bullet point 4',
            placeholder: 'Benefit 2 ...'
          },
          bullet_five: {
            title: 'Bullet point 5',
            placeholder: 'Material, Fabrics,...'
          },
          button_text: {
            title: 'Button Text',
            placeholder: 'Buy now, order now ...'
          },
          under_button_text: {
            title: 'Under Button text',
            placeholder: 'Pay by Cash on Delivery'
          }
        }
      }
    },
    single_image_block: {
      text: 'Single image',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          block_image_border_visibility: {
            title: 'Show image borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          vertical_spaces: {
            title: 'Spaces on Top and Bottom'
          },
          mobile_horizontal_spaces: {
            title: 'Spaces on Sides (for Mobile)'
          },
          image_max_width: {
            title: 'image max width',
            placeholder: 'type the max with of your image',
            hint: 'ps: it\'s recommended that you set a value between 500 and 700'
          }
        }
      }
    },
    trust_block: {
      text: 'Custom Badges',
      buttons: {
        add: 'Add badge'
      },
      form: {
        fields: {
          fill: {
            options: {
              satisfaction_guarantee: 'Satisfaction Guarantee'
            }
          },
          title: {
            title: 'Headline',
            placeholder: 'Headline...'
          },
          paragraph: {
            title: 'Sub-headline',
            placeholder: 'Sub-headline...'
          },
          badges_list: {
            title: 'Badges List',
            placeholder: 'Badges list...'
          }
        }
      }
    },
    trust_badge_block: {
      text: 'Custom Badge',
      form: {
        fields: {
          image: {
            title: 'Badge image'
          },
          text: {
            title: 'image Text',
            placeholder: 'image text...'
          }
        }
      }
    },
    video_block: {
      text: 'Video',
      form: {
        fields: {
          block_visibility: {
            title: 'Show block borders'
          },
          background_color: {
            title: 'Background color'
          },
          type: {
            title: 'Show block in'
          },
          title: {
            title: 'Headline',
            placeholder: 'type your headline'
          },
          video: {
            title: 'Product video',
            placeholder: 'example: https://youtube.com?v=xxxx'
          }
        }
      }
    }
  }
};